/* eslint-disable react/display-name */
/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { clone } from 'ramda';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import {
  DatePicker,
  TimePicker,
  Checkbox,
  PressedButton,
  PopupMenu,
  TextInput
} from 'quantux-ui';
import {
  updateNewCaseScheduleData,
  setCaseTabFlag,
  updateCaseSchedule,
  updateCaseBlockActiveCaseSchedule,
  initiateFacilitySearch,
  searchFacilities,
  resetFacilitySearch,
  initiateSurgeonSearch,
  searchSurgeons,
  resetSurgeonSearch,
  initiateAnesthesiologistSearch,
  searchAnesthesiologists,
  resetAnesthesiologistSearch,
  initiateCrnaSearch,
  searchCrnas,
  resetCrnaSearch,
  initiateCptSearch,
  searchCpt,
  resetCptSearch,
  initiateIcd10Search,
  searchIcd10,
  resetIcd10Search,
  shouldResyncCaseData,
  setShouldSaveCaseData
} from '../../actions';
import {
  getHighlightedText,
  FLAG_VALUE,
  getWeekDay,
  getMonthName,
  getShortWeekDay,
  parseDateFromIsoString,
  debugLogToConsole,
  makeIsoDateString,
  PATIENT_TYPE,
  DEBOUNCE_TIME,
  CASE_SCHEDULE_OP_MODE
} from '../../utils';
import PracticeProviderCard from './practice-provider-card';
import ProviderPracticeCard from './provider-practice-card';
import CaseUserCard from '../revenue-cycle-management/case-user-card';
import CaseField from '../revenue-cycle-management/case-field';
import FacilityLocationCard from './facility-location-card';
import CriticalWarningIcon from '../svg-icons/critical-warning-icon';
import WarningIcon from '../svg-icons/warning-icon';
import SuccessIcon from '../svg-icons/success-icon';
import { gray, blue, yellow, salmon } from '../../theme';

// Constants
const DRAWER_WIDTH = 355;
const TODAY = new Date();

const CaseTab = (props) => {
  const [user, setUser] = useState();
  const [practice, setPractice] = useState();
  const [caseData, setCaseData] = useState({});
  // -- Case creation date and user name
  const [caseCreationDate, setCaseCreationDate] = useState(TODAY);
  const [caseUserName, setCaseUserName] = useState('');
  // --- TBD | TF
  const [isDosTbd, setIsDosTbd] = useState(false);
  const [isScheduleTimeTF, setIsScheduleTimeTF] = useState(false);
  // --- Schedule Start Time
  const [showScheduleTimeCriticalWarning, setShowScheduleTimeCriticalWarning] = useState(true);
  const [scheduleStartDate, setScheduleStartDate] = useState(TODAY.getDate());
  const [scheduleStartMonth, setScheduleStartMonth] = useState(TODAY.getMonth());
  const [scheduleStartYear, setScheduleStartYear] = useState(TODAY.getFullYear());
  const [isScheduleStartDatePristine, setIsScheduleStartDatePristine] = useState(true);
  const [scheduleStartHour, setScheduleStartHour] = useState(TODAY.getHours());
  const [scheduleStartMinute, setScheduleStartMinute] = useState(TODAY.getMinutes());
  const [isScheduleStartTimePristine, setIsScheduleStartTimePristine] = useState(true);
  // --- Schedule End Time
  const [scheduleEndDate, setScheduleEndDate] = useState(TODAY.getDate());
  const [scheduleEndMonth, setScheduleEndMonth] = useState(TODAY.getMonth());
  const [scheduleEndYear, setScheduleEndYear] = useState(TODAY.getFullYear());
  const [isScheduleEndDatePristine, setIsScheduleEndDatePristine] = useState(true);
  const [showEndDateCriticalWarning, setShowEndDateCriticalWarning] = useState(true);
  const [scheduleEndHour, setScheduleEndHour] = useState(TODAY.getHours());
  const [scheduleEndMinute, setScheduleEndMinute] = useState(TODAY.getMinutes());
  const [isScheduleEndTimePristine, setIsScheduleEndTimePristine] = useState(true);
  // --- Admission Type
  const [patientType, setPatientType] = useState('');
  // --- Facility
  const [facility, setFacility] = useState({});
  const [facilityValue, setFacilityValue] = useState('');
  const [showFacilitySearchMenu, setShowFacilitySearchMenu] = useState(false);
  const [selectedFacilityLocation, setSelectedFacilityLocation] = useState('TBD (To Be Determined)');
  const [showFacilityCriticalWarning, setShowFacilityCriticalWarning] = useState(true);
  const [showFacilityWarning, setShowFacilityWarning] = useState(true);
  // --- Surgeon
  const [surgeons, setSurgeons] = useState([]);
  const [surgeonValue, setSurgeonValue] = useState('');
  const [showSurgeonsSearchMenu, setShowSurgeonsSearchMenu] = useState(false);
  const [surgeonSearchPractices, setSurgeonSearchPractices] = useState([]);
  const [surgeonPractices, setSurgeonPractices] = useState([]);
  const [showSurgeonCriticalWarning, setShowSurgeonCriticalWarning] = useState(true);
  // --- Surgical Procedures ---
  const [surgicalProcedures, setSurgicalProcedures] = useState([]);
  const [procedureValue, setProcedureValue] = useState('');
  const [showProceduresSearchMenu, setShowProceduresSearchMenu] = useState(false);
  const [showSurgicalProceduresCriticalWarning, setShowSurgicalProceduresCriticalWarning] = useState(true);
  const [showSurgicalProceduresWarning, setShowSurgicalProceduresWarning] = useState(false);
  // --- PreOp DX ---
  const [preOpDxValue, setPreOpDxValue] = useState('');
  const [showPreOpDxSearchMenu, setShowPreOpDxSearchMenu] = useState(false);
  const [preOpDx, setPreOpDx] = useState([]);
  const [showPreOpDxWarningMessage, setShowPreOpDxWarningMessage] = useState(true);
  const [isSkipPreOpDx, setIsSkipPreOpDx] = useState(false);
  const [showPreOpDxCriticalWarning, setShowPreOpDxCriticalWarning] = useState(true);
  const [showPreOpDxWarning, setShowPreOpDxWarning] = useState(false);
  // --- PostOp DX ---
  const [postOpDxValue, setPostOpDxValue] = useState('');
  const [showPostOpDxSearchMenu, setShowPostOpDxSearchMenu] = useState(false);
  const [postOpDx, setPostOpDx] = useState([]);
  const [showPostOpDxWarningMessage, setShowPostOpDxWarningMessage] = useState(true);
  const [isSameAsPreOpDx, setIsSameAsPreOpDx] = useState(false);
  const [showPostOpDxCriticalWarning, setShowPostOpDxCriticalWarning] = useState(true);
  const [showPostOpDxWarning, setShowPostOpDxWarning] = useState(false);
  // --- Anesthesiologists
  const [anesthesiologists, setAnesthesiologists] = useState([]);
  const [anesthesiologistValue, setAnesthesiologistValue] = useState('');
  const [showAnesthesiologistsSearchMenu, setShowAnesthesiologistsSearchMenu] = useState(false);
  const [isNoneAnesthesiologist, setIsNoneAnesthesiologist] = useState(false);
  const [showAnesthesiologistCriticalWarning, setShowAnesthesiologistCriticalWarning] = useState(true);
  const [showAnesthesiologistWarning, setShowAnesthesiologistWarning] = useState(false);
  const [showAnesthesiologistNoneFlag, setShowAnesthesiologistNoneFlag] = useState(false);
  // -- CRNA
  const [crnas, setCrnas] = useState([]);
  const [isNoneCrna, setIsNoneCrna] = useState(false);
  const [crnaValue, setCrnaValue] = useState('');
  const [showCrnasSearchMenu, setShowCrnasSearchMenu] = useState(false);
  const [showCrnaCriticalWarning, setShowCrnaCriticalWarning] = useState(true);
  const [showCrnaWarning, setShowCrnaWarning] = useState(false);
  const [showCrnaNoneFlag, setShowCrnaNoneFlag] = useState(false);
  // -- Anes Start
  const [anesthesiaStartHour, setAnesthesiaStartHour] = useState(TODAY.getHours());
  const [anesthesiaStartMinute, setAnesthesiaStartMinute] = useState(TODAY.getMinutes());
  const [isAnesthesiaStartTimePristine, setIsAnesthesiaStartTimePristine] = useState(true);
  window.isAnesthesiaStartTimePristine = isAnesthesiaStartTimePristine;
  const [anesthesiaStartDate, setAnesthesiaStartDate] = useState(TODAY.getDate());
  const [anesthesiaStartMonth, setAnesthesiaStartMonth] = useState(TODAY.getMonth());
  const [anesthesiaStartYear, setAnesthesiaStartYear] = useState(TODAY.getFullYear());
  // -- Surg Start
  const [surgeryStartHour, setSurgeryStartHour] = useState(TODAY.getHours());
  const [surgeryStartMinute, setSurgeryStartMinute] = useState(TODAY.getMinutes());
  const [isSurgeryStartTimePristine, setIsSurgeryStartTimePristine] = useState(true);
  const [surgeryStartDate, setSurgeryStartDate] = useState(TODAY.getDate());
  const [surgeryStartMonth, setSurgeryStartMonth] = useState(TODAY.getMonth());
  const [surgeryStartYear, setSurgeryStartYear] = useState(TODAY.getFullYear());
  // -- Surg End
  const [surgeryEndHour, setSurgeryEndHour] = useState(TODAY.getHours());
  const [surgeryEndMinute, setSurgeryEndMinute] = useState(TODAY.getMinutes());
  const [isSurgeryEndTimePristine, setIsSurgeryEndTimePristine] = useState(true);
  const [surgeryEndDate, setSurgeryEndDate] = useState(TODAY.getDate());
  const [surgeryEndMonth, setSurgeryEndMonth] = useState(TODAY.getMonth());
  const [surgeryEndYear, setSurgeryEndYear] = useState(TODAY.getFullYear());
  // -- Anes End
  const [anesthesiaEndHour, setAnesthesiaEndHour] = useState(TODAY.getHours());
  const [anesthesiaEndMinute, setAnesthesiaEndMinute] = useState(TODAY.getMinutes());
  const [isAnesthesiaEndTimePristine, setIsAnesthesiaEndTimePristine] = useState(true);
  const [anesthesiaEndDate, setAnesthesiaEndDate] = useState(TODAY.getDate());
  const [anesthesiaEndMonth, setAnesthesiaEndMonth] = useState(TODAY.getMonth());
  const [anesthesiaEndYear, setAnesthesiaEndYear] = useState(TODAY.getFullYear());
  // --- Lien, Workman Comp, Unknown End and Scheduling Notes
  const [lien, setLien] = useState('No');
  const [workmanComp, setWorkmanComp] = useState('No');
  const [unknownEnd, setUnknownEnd] = useState('No');
  const [schedulingNotes, setSchedulingNotes] = useState('');
  // Flags
  // Anes Start
  const [showAnesStartDateWarning, setShowAnesStartDateWarning] = useState(false);
  // Surg Start
  const [showSurgStartWarning, setShowSurgStartWarning] = useState(true);
  const [showSurgStartDateWarning, setShowSurgStartDateWarning] = useState(false);
  // Surg End
  const [showSurgEndWarning, setShowSurgEndWarning] = useState(true);
  const [showSurgEndDateWarning, setShowSurgEndDateWarning] = useState(false);
  // Anes End
  const [showAnesEndWarning, setShowAnesEndWarning] = useState(true);
  const [showAnesEndDateWarning, setShowAnesEndDateWarning] = useState(false);
  const [showCaseTimesMasterWarning, setShowCaseTimesMasterWarning] = useState(true);

  // --- Debounced Facility Search
  const debouncedFacilitySearch = useCallback(
    debounce(value => props.searchFacilities(value), DEBOUNCE_TIME),
    []
  );
  // --- Debounced Surgeon Search
  const debouncedSurgeonsSearch = useCallback(
    debounce(value => props.searchSurgeons(value), DEBOUNCE_TIME),
    []
  );
  // --- Debounced Surgical Procedures Search
  const debouncedProceduresSearch = useCallback(
    debounce(value => props.searchCpt(value), DEBOUNCE_TIME * 2),
    []
  );
  // Debounced Anesthesiologist Search
  const debouncedAnesthesiologistsSearch = useCallback(
    debounce(value => props.searchAnesthesiologists(value), DEBOUNCE_TIME),
    []
  );
  // Debounced CRNAs Search
  const debouncedCrnasSearch = useCallback(
    debounce(value => props.searchCrnas(value), DEBOUNCE_TIME),
    []
  );

  // --- PreOP DX Search
  const debouncedPreOpDxSearch = useCallback(
    debounce(value => props.searchIcd10(value), DEBOUNCE_TIME),
    []
  );

  // --- PostOP DX Search
  const debouncedPostOpDxSearch = useCallback(
    debounce(value => props.searchIcd10(value), DEBOUNCE_TIME),
    []
  );

  // ___ EFFECTS ______________________________________________________________
  useEffect(() => {
    if (!user && !practice) {
      const usr = localStorage.getItem('usr');
      const selectedPractice = localStorage.getItem('selectedPractice');

      if (usr) {
        setUser(JSON.parse(usr));
      }

      if (selectedPractice) {
        setPractice(JSON.parse(selectedPractice));
      }

      // Loading intial data for case block case
      if (props.opMode === CASE_SCHEDULE_OP_MODE.caseBlockNewCase) {
        setFacility(props.caseBlockActiveCaseSchedule.facility);
        setSelectedFacilityLocation(props.caseBlockActiveCaseSchedule.selectedLocation);
        setSurgeons(props.caseBlockActiveCaseSchedule.surgeons);
        setAnesthesiologists(props.caseBlockActiveCaseSchedule.anesthesiologists);
        setCrnas(props.caseBlockActiveCaseSchedule.crnas);
        setIsNoneAnesthesiologist(props.caseBlockActiveCaseSchedule.isNoneAnesthesiologist);
        setIsNoneCrna(props.caseBlockActiveCaseSchedule.isNoneCrna);
      }

      if (props.opMode === CASE_SCHEDULE_OP_MODE.newSchedule) {
        setFacility(props.newCaseSchedule.facility);
        setSelectedFacilityLocation(props.newCaseSchedule.selectedFacilityLocation);
      }

      // Case Block Active Case Schedule
      if (props.isEditingCaseBlock) {
        setSelectedFacilityLocation(props.caseBlockActiveCaseSchedule.selectedLocation);
      }
    }
  }, []);

  // Load case data from props.newCaseSchedule
  // useEffect(() => {
  //   debugLogToConsole('Case Data Effect --- props.newCaseSchedule');
  //   // In dashboard mode, props.newCaseSchedule is not applicable
  //   const { isDashboard, newCaseSchedule } = props;
  //   const { lastUpdateTime = 0 } = caseData;
  //   if (!isDashboard && Object.keys(newCaseSchedule).length > 0 && newCaseSchedule.lastUpdateTime !== lastUpdateTime) {
  //     setCaseData(props.newCaseSchedule);
  //   }
  // }, [props.newCaseSchedule]);

  // Resync case data
  useEffect(() => {
    if (props.resyncCaseData) {
      // In dashboard mode, props.newCaseSchedule is not applicable
      const { isDashboard, newCaseSchedule } = props;
      const { lastUpdateTime = 0 } = caseData;
      // if (!isDashboard && Object.keys(newCaseSchedule).length > 0 && newCaseSchedule.lastUpdateTime !== lastUpdateTime) {
      //   setCaseData(props.newCaseSchedule);
      // }
      if (Object.keys(newCaseSchedule).length > 0) {
        setCaseData(props.newCaseSchedule);
      }

      if (props.forCaseBlocks) {
        setCaseData(props.caseBlockActiveCaseSchedule);
      }
      props.shouldResyncCaseData(false);
    }
  }, [props.resyncCaseData]);

  // Load case data from props.activeCaseSchedule
  useEffect(() => {
    if (!props.forCaseBlocks && props.isDashboard) {
      // debugLogToConsole('Case Data Effect --- props.activeCaseSchedule');
      if (Object.keys(props.activeCaseSchedule).length > 0) {
        // debugLogToConsole('Existing Case data set!');
        // debugLogToConsole(props.activeCaseSchedule);
        setCaseData(props.activeCaseSchedule);
      }
    }
  }, [props.activeCaseSchedule]);

  const initLoadRef = useRef({ data: true });

  useEffect(() => {
    if (props.forCaseBlocks) {
      debugLogToConsole('Case Data Effect --- props.caseBlockActiveCaseSchedule');
      if (initLoadRef.current && initLoadRef.current.data && Object.keys(props.caseBlockActiveCaseSchedule).length > 0) {
        debugLogToConsole('Existing Case data set!');
        debugLogToConsole(props.caseBlockActiveCaseSchedule);
        setCaseData(props.caseBlockActiveCaseSchedule);
        initLoadRef.current.data = false;
      }
    }
  }, [props.caseBlockActiveCaseSchedule]);

  // Read case data from redux caseSchedule store &
  // assign values to state vars
  useEffect(() => {
    // Case creation date
    if (caseData && caseData.caseCreationDate) {
      setCaseCreationDate(new Date(caseData.creationDate));
    }

    // Case user name
    if (caseData && caseData.createdBy) {
      setCaseUserName(caseData.createdBy);
    }

    // AnesStart Date & Time
    if (caseData.anesthesiaStartDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.anesthesiaStartDate);
      setAnesthesiaStartDate(date);
      setAnesthesiaStartMonth(month);
      setAnesthesiaStartYear(year);
    }

    if (caseData.anesthesiaStartHour !== undefined &&
      caseData.anesthesiaStartMinute !== undefined) {
      setAnesthesiaStartHour(caseData.anesthesiaStartHour);
      setAnesthesiaStartMinute(caseData.anesthesiaStartMinute);
      setIsAnesthesiaStartTimePristine(false);
    }

    // SurgStart Date & Time
    if (caseData.surgeryStartDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.surgeryStartDate);
      setSurgeryStartDate(date);
      setSurgeryStartMonth(month);
      setSurgeryStartYear(year);
    }

    if (caseData.surgeryStartHour !== undefined &&
      caseData.surgeryStartMinute !== undefined) {
      setSurgeryStartHour(caseData.surgeryStartHour);
      setSurgeryStartMinute(caseData.surgeryStartMinute);
      setIsSurgeryStartTimePristine(false);
    }

    // SurgEnd Date & Time
    if (caseData.surgeryEndDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.surgeryEndDate);
      setSurgeryEndYear(year);
      setSurgeryEndMonth(month);
      setSurgeryEndDate(date);
    }

    if (caseData.surgeryEndHour !== undefined &&
      caseData.surgeryEndMinute !== undefined) {
      setSurgeryEndHour(caseData.surgeryEndHour);
      setSurgeryEndMinute(caseData.surgeryEndMinute);
      setIsSurgeryEndTimePristine(false);
    }

    // Anesthesia End Date & Time
    if (caseData.anesthesiaEndDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.anesthesiaEndDate);
      setAnesthesiaEndYear(year);
      setAnesthesiaEndMonth(month);
      setAnesthesiaEndDate(date);
    }

    if (caseData.anesthesiaEndHour !== undefined &&
      caseData.anesthesiaEndMinute !== undefined) {
      setAnesthesiaEndHour(caseData.anesthesiaEndHour);
      setAnesthesiaEndMinute(caseData.anesthesiaEndMinute);
      setIsAnesthesiaEndTimePristine(false);
    }

    // Schedule TF, TBD
    if (caseData.hasOwnProperty('isScheduleTimeTF')) {
      setIsScheduleTimeTF(caseData.isScheduleTimeTF);
    }
    if (caseData.hasOwnProperty('isDosTbd')) {
      setIsDosTbd(caseData.isDosTbd);
    }

    // Schedule Start Date
    if (caseData.scheduleStartDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.scheduleStartDate);
      setScheduleStartYear(year);
      setScheduleStartMonth(month);
      setScheduleStartDate(date);
      setIsScheduleStartDatePristine(false);
    }
    if (caseData.hasOwnProperty('scheduleStartHour') && caseData.hasOwnProperty('scheduleStartMinute')) {
      setScheduleStartHour(caseData.scheduleStartHour);
      setScheduleStartMinute(caseData.scheduleStartMinute);
      setIsScheduleStartTimePristine(false);
    }

    // Schedule End Date
    if (caseData.scheduleEndDate) {
      const { year, month, date } = parseDateFromIsoString(caseData.scheduleEndDate);
      setScheduleEndYear(year);
      setScheduleEndMonth(month);
      setScheduleEndDate(date);
      setIsScheduleEndDatePristine(false);
    }
    if (caseData.hasOwnProperty('scheduleEndHour') && caseData.hasOwnProperty('scheduleEndMinute')) {
      setScheduleEndHour(caseData.scheduleEndHour);
      setScheduleEndMinute(caseData.scheduleEndMinute);
      setIsScheduleEndTimePristine(false);
    }

    // Patient Type
    if (caseData.patientType) {
      setPatientType(caseData.patientType);
    }

    // Facility and Selected Facility Location
    if (caseData.facility && Object.keys(caseData.facility).length > 0) {
      setFacility(caseData.facility);
    }
    if (caseData.selectedFacilityLocation) {
      setSelectedFacilityLocation(caseData.selectedFacilityLocation);
    }

    // Surgeons
    if (caseData.surgeons && caseData.surgeons.length > 0) {
      setSurgeons(caseData.surgeons);
    }

    // Surgical Procedures
    let tmpSurgicalProcedures = [];
    if (caseData.surgicalProcedures) {
      tmpSurgicalProcedures = tmpSurgicalProcedures.concat(caseData.surgicalProcedures);
    }
    if (caseData.otherSurgicalProcedures) {
      tmpSurgicalProcedures = tmpSurgicalProcedures.concat(caseData.otherSurgicalProcedures);
    }
    setSurgicalProcedures(tmpSurgicalProcedures);

    // PreOp Dx & Skip PreOp Dx
    let tmpPreOpDx = [];
    if (caseData.preOpDx) {
      tmpPreOpDx = tmpPreOpDx.concat(caseData.preOpDx);
    }
    if (caseData.otherPreOpDx) {
      tmpPreOpDx = tmpPreOpDx.concat(caseData.otherPreOpDx);
    }
    setPreOpDx(tmpPreOpDx);
    if (caseData.hasOwnProperty('isSkipPreOpDx')) {
      setIsSkipPreOpDx(caseData.isSkipPreOpDx);
    }

    // PostOp Dx && Same as PreOp Dx
    let tmpPostOpDx = [];
    if (caseData.postOpDx) {
      tmpPostOpDx = tmpPostOpDx.concat(caseData.postOpDx);
    }
    if (caseData.otherPostOpDx) {
      tmpPostOpDx = tmpPostOpDx.concat(caseData.otherPostOpDx);
    }
    setPostOpDx(tmpPostOpDx);
    if (caseData.hasOwnProperty('isSameAsPreOpDx')) {
      setIsSameAsPreOpDx(caseData.isSameAsPreOpDx);
    }

    // Anesthesiologists
    if (caseData.anesthesiologists) {
      setAnesthesiologists(caseData.anesthesiologists);
    }
    if (caseData.hasOwnProperty('isNoneAnesthesiologist')) {
      setIsNoneAnesthesiologist(caseData.isNoneAnesthesiologist);
    }

    // CRNA
    if (caseData.crnas) {
      setCrnas(caseData.crnas);
    }
    if (caseData.hasOwnProperty('isNoneCrna')) {
      setIsNoneCrna(caseData.isNoneCrna);
    }

    // Lien, Workman Comp, Unknown end and Scheduling Notes
    if (caseData.lien) {
      setLien(caseData.lien);
    }
    if (caseData.workmanComp) {
      setWorkmanComp(caseData.workmanComp);
    }
    if (caseData.unknownEnd) {
      setUnknownEnd(caseData.unknownEnd);
    }
    if (caseData.schedulingNotes) {
      setSchedulingNotes(caseData.schedulingNotes);
    }
  }, [caseData]);

  // -- Schedule End Date Flag
  useEffect(() => {
    if (isScheduleStartTimePristine || isScheduleEndTimePristine) {
      setShowEndDateCriticalWarning(true);
      setShowScheduleTimeCriticalWarning(true);
    } else {
      const start = new Date(scheduleStartYear, scheduleStartMonth, scheduleStartDate, scheduleStartHour, scheduleStartMinute).getTime();
      const stop = new Date(scheduleEndYear, scheduleEndMonth, scheduleEndDate, scheduleEndHour, scheduleEndMinute).getTime();
      setShowEndDateCriticalWarning(stop - start <= 0);
      setShowScheduleTimeCriticalWarning(stop - start <= 0);

      if (props.isDashboard && stop - start > 0) {
        // setCheckInDate(scheduleEndDate);
        // setCheckInMonth(scheduleEndMonth);
        // setCheckInYear(scheduleEndYear);
        if (props.forCaseBlocks) {
          props.updateCaseBlockActiveCaseSchedule({
            checkInDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            preOpDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            anesthesiaStartDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            inDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            surgeryStartDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            surgeryEndDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            outDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            phoDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            anesthesiaEndDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            dcDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate)
          });
        } else {
          props.updateCaseSchedule({
            checkInDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            preOpDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            anesthesiaStartDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            inDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            surgeryStartDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            surgeryEndDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            outDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            phoDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            anesthesiaEndDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate),
            dcDate: makeIsoDateString(scheduleEndYear, scheduleEndMonth, scheduleEndDate)
          });
        }

        setAnesthesiaStartDate(scheduleEndDate);
        setAnesthesiaStartMonth(scheduleEndMonth);
        setAnesthesiaStartYear(scheduleEndYear);

        setSurgeryStartDate(scheduleEndDate);
        setSurgeryStartMonth(scheduleEndMonth);
        setSurgeryStartYear(scheduleEndYear);

        setSurgeryEndDate(scheduleEndDate);
        setSurgeryEndMonth(scheduleEndMonth);
        setSurgeryEndYear(scheduleEndYear);

        setAnesthesiaEndDate(scheduleEndDate);
        setAnesthesiaEndMonth(scheduleEndMonth);
        setAnesthesiaEndYear(scheduleEndYear);
      }
    }
  }, [
    scheduleStartDate,
    scheduleStartMonth,
    scheduleStartYear,
    scheduleStartHour,
    scheduleStartMinute,
    isScheduleStartTimePristine,
    scheduleEndDate,
    scheduleEndMonth,
    scheduleEndYear,
    scheduleEndHour,
    scheduleEndMinute,
    isScheduleEndTimePristine
  ]);

  // -- Facility Search
  useEffect(() => {
    if (facilityValue.trim().length > 0) {
      if (!props.searchingFacilities) {
        props.initiateFacilitySearch();
      }
      debouncedFacilitySearch(facilityValue);
    }
  }, [facilityValue]);

  useEffect(() => {
    if (props.isDashboard) {
      if (Object.keys(facility).length === 0 || selectedFacilityLocation === 'TBD (To Be Determined)') {
        setShowFacilityCriticalWarning(true)
        setShowFacilityWarning(false);
      } else {
        setShowFacilityCriticalWarning(false)
        setShowFacilityWarning(false);
      }
    } else {
      setShowFacilityCriticalWarning(!(Object.keys(facility).length > 0));
      if (selectedFacilityLocation && selectedFacilityLocation.length === 0) {
        setShowFacilityWarning(true);
      } else {
        setShowFacilityWarning(selectedFacilityLocation === 'TBD (To Be Determined)');
      }
    }
  }, [facility, selectedFacilityLocation]);

  // -- Surgeon Search
  useEffect(() => {
    if (surgeonValue.trim().length > 0) {
      if (!props.searchingSurgeons) {
        props.initiateSurgeonSearch();
      }
      debouncedSurgeonsSearch(surgeonValue);
    }
  }, [surgeonValue]);

  // Surgeons list updated (both add & delete)
  useEffect(() => {
    setShowSurgeonCriticalWarning(surgeons.length === 0);
  }, [surgeons]);

  // -- Search Surgical Procedures
  useEffect(() => {
    if (procedureValue.trim().length > 2) {
      if (!props.searchingCptCodes) {
        props.initiateCptSearch();
      }
      debouncedProceduresSearch(procedureValue);
    }
  }, [procedureValue]);

  // Surgical Procedures flag
  useEffect(() => {
    if (surgicalProcedures.length === 0) {
      setShowSurgicalProceduresCriticalWarning(true);
      setShowSurgicalProceduresWarning(false);
    } else {
      const others = surgicalProcedures.filter(el => el.npi === 0);
      if (others.length === surgicalProcedures.length) {
        setShowSurgicalProceduresCriticalWarning(false);
        setShowSurgicalProceduresWarning(true);
      } else {
        setShowSurgicalProceduresCriticalWarning(false);
        setShowSurgicalProceduresWarning(false);
      }
    }
  }, [surgicalProcedures]);

  // PreOpDx Search
  useEffect(() => {
    if (preOpDxValue.trim().replace(/[/\-\\^$*+?.()|[\]{}]/g, '').length > 1) {
      if (!props.searchingIcd10) {
        props.initiateIcd10Search();
      }
      if (preOpDxValue.length > 2) {
        debouncedPreOpDxSearch(preOpDxValue);
      }
    }
  }, [preOpDxValue]);

  useEffect(() => {
    setShowPreOpDxWarningMessage(
      preOpDx.length > 0 &&
      (preOpDx.filter(el => el.npi === 0)).length > 0 &&
      (preOpDx.filter(el => el.npi === 0)).length === preOpDx.length
    );

    // PreOp Dx Flag
    if (props.isDashboard) {
      if (preOpDx.length === 0) {
        setShowPreOpDxCriticalWarning(true);
        setShowPreOpDxWarning(false);
      } else {
        const others = preOpDx.filter(el => el.npi === 0);
        if (others.length === preOpDx.length) {
          setShowPreOpDxCriticalWarning(false);
          setShowPreOpDxWarning(true);
        } else {
          setShowPreOpDxCriticalWarning(false);
          setShowPreOpDxWarning(false);
        }
      }
    } else {
      if (isSkipPreOpDx) {
        setShowPreOpDxCriticalWarning(false);
        setShowPreOpDxWarning(true);
      } else {
        if (preOpDx.length === 0) {
          setShowPreOpDxCriticalWarning(true);
          setShowPreOpDxWarning(false);
        } else {
          const others = preOpDx.filter(el => el.npi === 0);
          if (others.length === preOpDx.length) {
            setShowPreOpDxCriticalWarning(false);
            setShowPreOpDxWarning(true);
          } else {
            setShowPreOpDxCriticalWarning(false);
            setShowPreOpDxWarning(false);
          }
        }
      }
    }
  }, [preOpDx]);

  // PreOp Dx Flag
  useEffect(() => {
    if (isSkipPreOpDx) {
      setShowPreOpDxCriticalWarning(false);
      setShowPreOpDxWarning(true);
    } else {
      if (preOpDx.length === 0) {
        setShowPreOpDxCriticalWarning(true);
        setShowPreOpDxWarning(false);
      } else {
        const others = preOpDx.filter(el => el.npi === 0);
        if (others.length === preOpDx.length) {
          setShowPreOpDxCriticalWarning(false);
          setShowPreOpDxWarning(true);
        } else {
          setShowPreOpDxCriticalWarning(false);
          setShowPreOpDxWarning(false);
        }
      }
    }
  }, [isSkipPreOpDx]);

  // PostOpDx Search
  useEffect(() => {
    if (postOpDxValue.trim().length > 0) {
      if (!props.searchingIcd10) {
        props.initiateIcd10Search();
      }
      debouncedPostOpDxSearch(postOpDxValue);
    }
  }, [postOpDxValue]);

  useEffect(() => {
    setShowPostOpDxWarningMessage(
      postOpDx.length > 0 &&
      (postOpDx.filter(el => el.npi === 0)).length > 0 &&
      (postOpDx.filter(el => el.npi === 0)).length === postOpDx.length
    );
    // PostOp Dx Flag
    if (isSameAsPreOpDx) {
      setShowPostOpDxCriticalWarning(false);
      setShowPostOpDxWarning(false);
    } else {
      if (postOpDx.length === 0) {
        setShowPostOpDxCriticalWarning(true);
        setShowPostOpDxWarning(false);
      } else {
        const others = postOpDx.filter(el => el.npi === 0);
        if (others.length === postOpDx.length) {
          setShowPostOpDxCriticalWarning(false);
          setShowPostOpDxWarning(true);
        } else {
          setShowPostOpDxCriticalWarning(false);
          setShowPostOpDxWarning(false);
        }
      }
    }
  }, [postOpDx]);

  // PostOp Dx Flag
  useEffect(() => {
    if (isSameAsPreOpDx) {
      setShowPostOpDxCriticalWarning(false);
      setShowPostOpDxWarning(false);
    } else {
      if (postOpDx.length === 0) {
        setShowPostOpDxCriticalWarning(true);
        setShowPostOpDxWarning(false);
      } else {
        const others = postOpDx.filter(el => el.npi === 0);
        if (others.length === postOpDx.length) {
          setShowPostOpDxCriticalWarning(false);
          setShowPostOpDxWarning(true);
        } else {
          setShowPostOpDxCriticalWarning(false);
          setShowPostOpDxWarning(false);
        }
      }
    }
  }, [isSameAsPreOpDx]);

  // -- Anesthesiologist/Practice Search
  useEffect(() => {
    if (anesthesiologistValue.trim().length > 0) {
      if (!props.searchingAnesthesiologists) {
        props.initiateAnesthesiologistSearch();
      }
      debouncedAnesthesiologistsSearch(anesthesiologistValue);
    }
  }, [anesthesiologistValue]);

  // Anesthesiologist Flag
  useEffect(() => {
    if (isNoneAnesthesiologist) {
      setShowAnesthesiologistNoneFlag(true);
      setShowAnesthesiologistCriticalWarning(false);
      setShowAnesthesiologistWarning(false);
    } else {
      let anesthesiologistTimeFlag = FLAG_VALUE.success;
      for (let i = 0; i < anesthesiologists.length; i++) {
        const anes = anesthesiologists[i];
        if (anes.startFlag === FLAG_VALUE.critical || anes.stopFlag === FLAG_VALUE.critical) {
          anesthesiologistTimeFlag = FLAG_VALUE.critical;
          break;
        }
      }
      if (anesthesiologistTimeFlag === FLAG_VALUE.critical) {
        setShowAnesthesiologistNoneFlag(false);
        setShowAnesthesiologistWarning(false);
        setShowAnesthesiologistCriticalWarning(true);
      } else {
        setShowAnesthesiologistNoneFlag(false);
        if (anesthesiologists.length === 0) {
          setShowAnesthesiologistCriticalWarning(true);
          setShowAnesthesiologistWarning(false);
        } else {
          setShowAnesthesiologistCriticalWarning(false);
          setShowAnesthesiologistWarning(false);
        }
      }
    }
  }, [anesthesiologists, isNoneAnesthesiologist]);

  // -- CRNA/Practice Search
  useEffect(() => {
    if (crnaValue.trim().length > 0) {
      if (!props.searchingCrnas) {
        props.initiateCrnaSearch();
      }
      debouncedCrnasSearch(crnaValue);
    }
  }, [crnaValue]);

  // CRNA Flag
  useEffect(() => {
    if (isNoneCrna) {
      setShowCrnaNoneFlag(true);
      setShowCrnaCriticalWarning(false);
      setShowCrnaWarning(false);
    } else {
      let crnaTimeFlag = FLAG_VALUE.success;
      for (let i = 0; i < crnas.length; i++) {
        const crna = crnas[i];
        if (crna.startFlag === FLAG_VALUE.critical || crna.stopFlag === FLAG_VALUE.critical) {
          crnaTimeFlag = FLAG_VALUE.critical;
          break;
        }
      }
      if (crnaTimeFlag === FLAG_VALUE.critical) {
        setShowCrnaNoneFlag(false);
        setShowCrnaCriticalWarning(true);
        setShowCrnaWarning(false);
      } else {
        setShowCrnaNoneFlag(false);
        if (crnas.length === 0) {
          setShowCrnaCriticalWarning(true);
          setShowCrnaWarning(false);
        } else {
          setShowCrnaCriticalWarning(false);
          setShowCrnaWarning(false);
        }
      }
    }
  }, [isNoneCrna, crnas]);

  /* --- Case Times Flags -------------------------------------------------- */
  // Surgery Start Time Flag
  useEffect(() => {
    const a = new Date(anesthesiaStartYear, anesthesiaStartMonth, anesthesiaStartDate, anesthesiaStartHour, anesthesiaStartMinute).getTime();
    const b = new Date(surgeryStartYear, surgeryStartMonth, surgeryStartDate, surgeryStartHour, surgeryStartMinute).getTime();

    if (isAnesthesiaStartTimePristine || isSurgeryStartTimePristine) {
      setShowSurgStartWarning(true);
      setShowSurgStartDateWarning(false);
    } else if (a >= b) {
      setShowSurgStartWarning(true);
      setShowSurgStartDateWarning(true);
    } else {
      setShowSurgStartWarning(false);
      setShowSurgStartDateWarning(false);
    }
  }, [
    anesthesiaStartMonth,
    anesthesiaStartDate,
    anesthesiaStartYear,
    anesthesiaStartHour,
    anesthesiaStartMinute,
    isAnesthesiaStartTimePristine,
    surgeryStartDate,
    surgeryStartMonth,
    surgeryStartYear,
    surgeryStartHour,
    surgeryStartMinute,
    isSurgeryStartTimePristine
  ]);

  // Surgery End Time Flag
  useEffect(() => {
    const a = new Date(surgeryStartYear, surgeryStartMonth, surgeryStartDate, surgeryStartHour, surgeryStartMinute).getTime();
    const b = new Date(surgeryEndYear, surgeryEndMonth, surgeryEndDate, surgeryEndHour, surgeryEndMinute).getTime();

    if (isSurgeryStartTimePristine || isSurgeryEndTimePristine) {
      setShowSurgEndWarning(true);
      setShowSurgEndDateWarning(false);
    } else if (a >= b) {
      setShowSurgEndWarning(true);
      setShowSurgEndDateWarning(true);
    } else {
      setShowSurgEndWarning(false);
      setShowSurgEndDateWarning(false);
    }
  }, [
    surgeryStartDate,
    surgeryStartMonth,
    surgeryStartYear,
    surgeryStartHour,
    surgeryStartMinute,
    isSurgeryStartTimePristine,
    surgeryEndDate,
    surgeryEndMonth,
    surgeryEndYear,
    surgeryEndHour,
    surgeryEndMinute,
    isSurgeryEndTimePristine
  ]);

  // Anes End Time Flag
  useEffect(() => {
    const a = new Date(surgeryEndYear, surgeryEndMonth, surgeryEndDate, surgeryEndHour, surgeryEndMinute).getTime();
    const b = new Date(anesthesiaEndYear, anesthesiaEndMonth, anesthesiaEndDate, anesthesiaEndHour, anesthesiaEndMinute).getTime();

    if (isSurgeryEndTimePristine || isAnesthesiaEndTimePristine) {
      setShowAnesEndWarning(true);
      setShowAnesEndDateWarning(false);
    } else if (a >= b) {
      setShowAnesEndWarning(true);
      setShowAnesEndDateWarning(true);
    } else {
      setShowAnesEndWarning(false);
      setShowAnesEndDateWarning(false);
    }
  }, [
    surgeryEndDate,
    surgeryEndMonth,
    surgeryEndYear,
    surgeryEndHour,
    surgeryEndMinute,
    isSurgeryEndTimePristine,
    anesthesiaEndDate,
    anesthesiaEndMonth,
    anesthesiaEndYear,
    anesthesiaEndHour,
    anesthesiaEndMinute,
    isAnesthesiaEndTimePristine
  ]);

  // Case Times Master Flag
  useEffect(() => {
    setShowCaseTimesMasterWarning(
      isAnesthesiaStartTimePristine ||
      showSurgStartWarning ||
      showSurgEndWarning ||
      showAnesEndWarning
    );
  }, [
    isAnesthesiaStartTimePristine,
    showSurgStartWarning,
    showSurgEndWarning,
    showAnesEndWarning
  ]);

  // Case Tab Master Flag
  useEffect(() => {
    if (!props.isDashboard) {
      let caseTabFlag = FLAG_VALUE.success;
      if (showScheduleTimeCriticalWarning ||
        showFacilityCriticalWarning ||
        showSurgeonCriticalWarning ||
        showSurgicalProceduresCriticalWarning ||
        showPreOpDxCriticalWarning ||
        showAnesthesiologistCriticalWarning ||
        showCrnaCriticalWarning ||
        lien.length === 0 ||
        workmanComp.length === 0 ||
        unknownEnd.length === 0
      ) {
        caseTabFlag = FLAG_VALUE.critical;
        props.setCaseTabFlag(caseTabFlag);
        return;
      }

      if (patientType.length === 0 ||
        showFacilityWarning ||
        showSurgicalProceduresWarning ||
        showPreOpDxWarning ||
        showAnesthesiologistWarning ||
        showCrnaWarning
      ) {
        caseTabFlag = FLAG_VALUE.warning;
        props.setCaseTabFlag(caseTabFlag);
        return;
      }
      props.setCaseTabFlag(caseTabFlag);
    } else {
      let caseTabFlag = FLAG_VALUE.success;
      if (showScheduleTimeCriticalWarning ||
        showFacilityCriticalWarning ||
        showSurgeonCriticalWarning ||
        showSurgicalProceduresCriticalWarning ||
        showPreOpDxCriticalWarning ||
        showPostOpDxCriticalWarning ||
        showAnesthesiologistCriticalWarning ||
        showCrnaCriticalWarning ||
        showCaseTimesMasterWarning ||
        lien.length === 0 ||
        workmanComp.length === 0 ||
        unknownEnd.length === 0
      ) {
        caseTabFlag = FLAG_VALUE.critical;
        props.setCaseTabFlag(caseTabFlag);
        return;
      }

      if (patientType.length === 0 ||
        showFacilityWarning ||
        showSurgicalProceduresWarning ||
        showPreOpDxWarning ||
        showPostOpDxWarning ||
        showAnesthesiologistWarning ||
        showCrnaWarning
      ) {
        caseTabFlag = FLAG_VALUE.warning;
        props.setCaseTabFlag(caseTabFlag);
        return;
      }
      props.setCaseTabFlag(caseTabFlag);
    }
  }, [
    showScheduleTimeCriticalWarning,
    patientType,
    showFacilityCriticalWarning,
    showFacilityWarning,
    showSurgeonCriticalWarning,
    showSurgicalProceduresCriticalWarning,
    showSurgicalProceduresWarning,
    showPreOpDxCriticalWarning,
    showPreOpDxWarning,
    showPostOpDxCriticalWarning,
    showPostOpDxWarning,
    showAnesthesiologistCriticalWarning,
    showAnesthesiologistWarning,
    showAnesthesiologistNoneFlag,
    showCrnaCriticalWarning,
    showCrnaWarning,
    showCrnaNoneFlag,
    showCaseTimesMasterWarning,
    lien,
    workmanComp,
    unknownEnd
  ]);

  // -- Refs ------------------------------------------------------------
  const facilitySearchMenuRef = useRef();
  const surgeonSearchMenuRef = useRef();
  const procedureSearchMenuRef = useRef();
  const preOpDxSearchMenuRef = useRef();
  const postOpDxSearchMenuRef = useRef();
  const anesthesiologistSearchMenuRef = useRef();
  const crnaSearchMenuRef = useRef();

  // --- Styles ---------------------------------------------------------
  const styles = StyleSheet.create({
    practiceInfoContainer: {
      color: blue[200],
      borderBottom: `1px solid ${blue[700]}`
    },
    formField: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      color: blue[200]
    },
    lightBorderBottom: {
      borderBottom: `1px solid ${blue[700]}`
    },
    darkBottomBorder: {
      borderBottom: `1px solid ${gray[800]}`
    },
    formFieldDatePicker: {
      marginTop: '-4px'
    },
    formFieldTimePicker: {
      marginTop: '-4px'
    },
    pressedBtn: {
      fontSize: '12px',
      borderRadius: '2px'
    },
    admissionTypeBtn: {
      border: 'none'
    },
    pressedBtnCritical: {
      background: '#606000',
      color: '#FFFF00 !important'
    },
    pressedBtnWarning: {
      background: '#804254',
      color: '#FF6060 !important'
    },
    searchFormField: {
      position: 'relative',
      minHeight: '60px'
    },
    searchFormFieldTextboxContainer: {
      border: `1px solid ${blue[700]}`,
      borderRadius: '4px',
      position: 'relative'
    },
    searchPopupMenuPlaceholder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: `${DRAWER_WIDTH - 21}px`,
      height: '60px',
      padding: '8px'
    },
    menuItem: {
      cursor: 'pointer',
      background: gray[900],
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      fontSize: '14px',
      marginTop: '1px',
      ':hover': {
        background: '#184878',
        color: 'white'
      },
      ':last-child': {
        borderBottom: '0'
      }
    },
    menuItemSelected: {
      background: blue[400],
      color: 'white'
    },
    menuItemAvatarImg: {
      height: '30px',
      maxHeight: '30px',
      borderRadius: '4px'
    },
    menuItemText: {
      fontSize: '14px',
      lineHeight: '14px'
    },
    searchPopupMenuContainer: {
      width: `${DRAWER_WIDTH - 21}px`,
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto',
      maxHeight: '200px'
    },
    phoMenuContainer: {
      width: '100px',
      background: gray[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto',
      maxHeight: '200px'
    },
    notesTextArea: {
      background: 'white',
      color: 'black',
      width: `${DRAWER_WIDTH - 16}px`,
      height: '174px',
      fontSize: '16px',
      padding: '8px',
      borderColor: '#103A60',
      '::placeholder': {
        color: '#183C5A'
      }
    },
    spacer: {
      height: '50px'
    },
    footer: {
      height: '56px',
      padding: '0 8px',
      position: 'absolute',
      background: blue[700],
      width: '100%',
      bottom: '0',
      display: props.showFooter ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    disabled: {
      opacity: '0.5'
    },
    weekDayName: {
      color: blue[500]
    },
    fieldTextArea: {
      background: 'white',
      color: 'black',
      width: `${DRAWER_WIDTH - 16}px`,
      height: '80px',
      fontSize: '16px',
      padding: '8px',
      borderRadius: '4px',
      resize: 'none',
      borderColor: '#103A60',
      '::placeholder': {
        color: '#183C5A'
      }
    }
  });

  /* _____ EVENT HANDLERS ____________________________________________ */

  const handleOnChangeScheduleTimeTF = () => {
    setScheduleStartHour(TODAY.getHours());
    setScheduleStartMinute(TODAY.getMinutes());
    setIsScheduleStartTimePristine(true);
    setScheduleEndHour(TODAY.getHours());
    setScheduleEndMinute(TODAY.getMinutes());
    setIsScheduleEndTimePristine(true);
    setIsScheduleTimeTF(!isScheduleTimeTF);
    const scheduleTimesData = {
      scheduleStartHour: undefined,
      scheduleStartMinute: undefined,
      scheduleEndHour: undefined,
      scheduleEndMinute: undefined,
      isScheduleTimeTF: !isScheduleTimeTF
    };
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule(scheduleTimesData);
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData(scheduleTimesData);
      } else {
        props.updateCaseSchedule(scheduleTimesData);
      }
    }
  };

  const handleOnChangeTBD = () => {
    setIsDosTbd(!isDosTbd);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isDosTbd: !isDosTbd });
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({ isDosTbd: !isDosTbd });
      } else {
        props.updateCaseSchedule({ isDosTbd: !isDosTbd });
      }
    }
  };

  const handleOnChangeScheduleStartDate = (year, month, date) => {
    setScheduleStartDate(date);
    setScheduleStartMonth(month);
    setScheduleStartYear(year);
    setIsScheduleStartDatePristine(false);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        scheduleStartDate: makeIsoDateString(year, month, date)
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          scheduleStartDate: makeIsoDateString(year, month, date),
          showScheduleStartDayOfWeek: true
        });
      } else {
        props.updateCaseSchedule({
          scheduleStartDate: makeIsoDateString(year, month, date)
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnChangeScheduleEndDate = (year, month, date) => {
    setScheduleEndDate(date);
    setScheduleEndMonth(month);
    setScheduleEndYear(year);
    setIsScheduleEndDatePristine(false);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        scheduleEndDate: makeIsoDateString(year, month, date)
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          scheduleEndDate: makeIsoDateString(year, month, date),
          showScheduleEndDayOfWeek: true
        });
      } else {
        props.updateCaseSchedule({
          scheduleEndDate: makeIsoDateString(year, month, date)
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnChangeScheduleStartTime = (hour, min) => {
    setScheduleStartHour(hour);
    setScheduleStartMinute(min);
    setIsScheduleStartTimePristine(false);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        scheduleStartHour: hour,
        scheduleStartMinute: min
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          scheduleStartHour: hour,
          scheduleStartMinute: min
        });
      } else {
        props.updateCaseSchedule({
          scheduleStartHour: hour,
          scheduleStartMinute: min
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnChangeScheduleEndTime = (hour, min) => {
    setScheduleEndHour(hour);
    setScheduleEndMinute(min);
    setIsScheduleEndTimePristine(false);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        scheduleEndHour: hour,
        scheduleEndMinute: min
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          scheduleEndHour: hour,
          scheduleEndMinute: min
        });
      } else {
        props.updateCaseSchedule({
          scheduleEndHour: hour,
          scheduleEndMinute: min
        });
      }
    }
  };

  const handleOnClickOutPt = () => {
    if (patientType !== PATIENT_TYPE.OUT) {
      setPatientType(PATIENT_TYPE.OUT);
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ patientType: PATIENT_TYPE.OUT });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ patientType: PATIENT_TYPE.OUT });
        } else {
          props.updateCaseSchedule({ patientType: PATIENT_TYPE.OUT });
        }
      }
    } else {
      setPatientType('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ patientType: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ patientType: '' });
        } else {
          props.updateCaseSchedule({ patientType: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnClickInPt = () => {
    if (patientType !== PATIENT_TYPE.IN) {
      setPatientType(PATIENT_TYPE.IN);
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ patientType: PATIENT_TYPE.IN });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ patientType: PATIENT_TYPE.IN });
        } else {
          props.updateCaseSchedule({ patientType: PATIENT_TYPE.IN });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setPatientType('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ patientType: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ patientType: '' });
        } else {
          props.updateCaseSchedule({ patientType: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handelOnSelectFacilityLocation = (location) => {
    setSelectedFacilityLocation(location);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        selectedFacilityLocation: location
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          selectedFacilityLocation: location
        });
      } else {
        props.updateCaseSchedule({
          selectedFacilityLocation: location
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnDeleteFacility = () => {
    setFacility({});
    setSelectedFacilityLocation('TBD (To Be Determined)');

    if (props.forCaseBlocks) {
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        debugLogToConsole('NA');
      } else {
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const hanldeOnChangeSkipPreOpDx = () => {
    setPreOpDx([]);
    const newValue = !isSkipPreOpDx;
    setIsSkipPreOpDx(newValue);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isSkipPreOpDx: newValue });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({ isSkipPreOpDx: newValue });
      } else {
        props.updateCaseSchedule({ isSkipPreOpDx: newValue });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const hanldeOnChangeSameAsPreOpDx = () => {
    setPostOpDx([]);
    const newValue = !isSameAsPreOpDx;
    setIsSameAsPreOpDx(newValue);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({
        isSameAsPreOpDx: newValue,
        postOpDx: [],
        otherPostOpDx: []
      });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({
          isSameAsPreOpDx: newValue,
          postOpDx: [],
          otherPostOpDx: []
        });
      } else {
        props.updateCaseSchedule({
          isSameAsPreOpDx: newValue,
          postOpDx: [],
          otherPostOpDx: []
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnChangeIsNoneAnesthesiologist = () => {
    setAnesthesiologists([]);
    setAnesthesiologistValue('');
    const newValue = !isNoneAnesthesiologist;
    setIsNoneAnesthesiologist(newValue);

    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneAnesthesiologist: newValue });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({ isNoneAnesthesiologist: newValue });
      } else {
        props.updateCaseSchedule({
          isNoneAnesthesiologist: newValue,
          anesthesiologists: []
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnChangeIsNoneCrna = () => {
    setCrnas([]);
    setCrnaValue('');
    const newValue = !isNoneCrna;
    setIsNoneCrna(newValue);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneCrna: newValue });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({ isNoneCrna: newValue });
      } else {
        props.updateCaseSchedule({
          isNoneCrna: newValue,
          crnas: []
        });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  const handleOnClickNoLien = () => {
    if (lien === 'No') {
      setLien('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ lien: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ lien: '' });
        } else {
          props.updateCaseSchedule({ lien: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setLien('No');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ lien: 'No' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ lien: 'No' });
        } else {
          props.updateCaseSchedule({ lien: 'No' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnClickYesLien = () => {
    if (lien === 'Yes') {
      setLien('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ lien: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ lien: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        } else {
          props.updateCaseSchedule({ lien: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setLien('Yes');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ lien: 'Yes' });
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ lien: 'Yes' });
        } else {
          props.updateCaseSchedule({ lien: 'Yes' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnClickNoWorkmanComp = () => {
    if (workmanComp === 'No') {
      setWorkmanComp('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ workmanComp: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ workmanComp: '' });
        } else {
          props.updateCaseSchedule({ workmanComp: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setWorkmanComp('No');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ workmanComp: 'No' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ workmanComp: 'No' });
        } else {
          props.updateCaseSchedule({ workmanComp: 'No' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  }

  const handleOnClickYesWorkmanComp = () => {
    if (workmanComp === 'Yes') {
      setWorkmanComp('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ workmanComp: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ workmanComp: '' });
        } else {
          props.updateCaseSchedule({ workmanComp: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setWorkmanComp('Yes');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ workmanComp: 'Yes' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ workmanComp: 'Yes' });
        } else {
          props.updateCaseSchedule({ workmanComp: 'Yes' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnClickNoUnknownEnd = () => {
    if (unknownEnd === 'No') {
      setUnknownEnd('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ unknownEnd: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ unknownEnd: '' });
        } else {
          props.updateCaseSchedule({ unknownEnd: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setUnknownEnd('No');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ unknownEnd: 'No' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ unknownEnd: 'No' });
        } else {
          props.updateCaseSchedule({ unknownEnd: 'No' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnClickYesUnknownEnd = () => {
    if (unknownEnd === 'Yes') {
      setUnknownEnd('');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ unknownEnd: '' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ unknownEnd: '' });
        } else {
          props.updateCaseSchedule({ unknownEnd: '' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    } else {
      setUnknownEnd('Yes');
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ unknownEnd: 'Yes' });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      } else {
        if (!props.isDashboard) {
          props.updateNewCaseScheduleData({ unknownEnd: 'Yes' });
        } else {
          props.updateCaseSchedule({ unknownEnd: 'Yes' });
          if (!props.shoudlSaveCaseData) {
            props.setShouldSaveCaseData(true);
          }
        }
      }
    }
  };

  const handleOnChangeSchedulingNotes = (e) => {
    const { value } = e.target;
    // debugLogToConsole(`Scheduling Notes = ${value}`);
    setSchedulingNotes(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ schedulingNotes: value });
      if (!props.shoudlSaveCaseData) {
        props.setShouldSaveCaseData(true);
      }
    } else {
      if (!props.isDashboard) {
        props.updateNewCaseScheduleData({ schedulingNotes: value });
      } else {
        props.updateCaseSchedule({ schedulingNotes: value });
        if (!props.shoudlSaveCaseData) {
          props.setShouldSaveCaseData(true);
        }
      }
    }
  };

  // *** Surgical Procedures MENU ITEMS ***
  const procedureSearchItems = [];
  // Append search text
  if (procedureValue.length > 0) {
    procedureSearchItems.push(
      <div
        key='88888999SurgProcedure'
        className={`fx fx__v-center ${css(styles.menuItem)}`}
        onClick={(e) => {
          e.stopPropagation();
          const tmpProc = {
            id: Math.random().toString(36).slice(2),
            text: procedureValue,
            code: '',
            description: procedureValue,
            npi: 0
          };
          setShowProceduresSearchMenu(false);
          setProcedureValue('');
          setSurgicalProcedures((prevState) => {
            return prevState.concat(tmpProc);
          });
          const updatedSurgicalProcedures = surgicalProcedures.concat(tmpProc);
          if (props.forCaseBlocks) {
            props.updateCaseBlockActiveCaseSchedule({
              surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
              otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
            });
            if (!props.shoudlSaveCaseData) {
              props.setShouldSaveCaseData(true);
            }
          }
          if (!props.isDashboard) {
            props.updateNewCaseScheduleData({
              surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
              otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
            });
          }

          if (props.isDashboard) {
            props.updateCaseSchedule({
              surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
              otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
            });
            if (!props.shoudlSaveCaseData) {
              props.setShouldSaveCaseData(true);
            }
          }
        }}
      >
        <div className='ml-2'>
          <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
            {procedureValue}
          </div>
        </div>
      </div>
    );
  }
  // Appending search results to surgical procedures menu items
  if (Array.isArray(props.cptCodesSearchResults) &&
    props.cptCodesSearchResults.length > 0) {
    props.cptCodesSearchResults.forEach((el) => {
      procedureSearchItems.push(
        <div
          key={el._id}
          className={`fx fx__v-center ${css(styles.menuItem)}`}
          onClick={(e) => {
            e.stopPropagation();
            setShowProceduresSearchMenu(false);
            setProcedureValue('');
            const tmpSurgicalProcedure = {
              id: el._id,
              text: `${el.shortDescription}`,
              code: el.code,
              description: `${el.shortDescription}`,
              npi: el.npi
            };
            setSurgicalProcedures((prevState) => {
              if (prevState.findIndex(item => item.id === el._id) < 0) {
                return prevState.concat(tmpSurgicalProcedure);
              } else {
                return prevState;
              }
            });
            props.resetCptSearch();
            const updatedSurgicalProcedures = surgicalProcedures.concat(tmpSurgicalProcedure);
            if (props.forCaseBlocks) {
              props.updateCaseBlockActiveCaseSchedule({
                surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
              });
              if (!props.shoudlSaveCaseData) {
                props.setShouldSaveCaseData(true);
              }
            } else {
              if (!props.isDashboard) {
                props.updateNewCaseScheduleData({
                  surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                  otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
                });
              }

              if (props.isDashboard) {
                props.updateCaseSchedule({
                  surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                  otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
                });
                if (!props.shoudlSaveCaseData) {
                  props.setShouldSaveCaseData(true);
                }
              }
            }
          }}
        >
          <div className='ml-2'>
            <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
              {getHighlightedText(el.shortDescription, procedureValue)}
            </div>
          </div>
        </div>
      );
    });
  }

  // *** PreOP DX MENU ITEMS ***
  const preOpDxSearchItems = [];
  // Append search text
  if (preOpDxValue.length > 0) {
    preOpDxSearchItems.push(
      <div
        key='877891781preOp'
        className={`fx fx__v-center ${css(styles.menuItem)}`}
        style={{ height: '40px' }}
        onClick={(e) => {
          e.stopPropagation();
          const tmpDx = {
            id: Math.random().toString(36).slice(2),
            code: '',
            description: preOpDxValue,
            npi: 0
          };
          setShowPreOpDxSearchMenu(false);
          setPreOpDxValue('');

          setPreOpDx((prevState) => {
            return prevState.concat(tmpDx);
          });
          const updatedPreOpDx = preOpDx.concat(tmpDx);
          if (props.forCaseBlocks) {
            props.updateCaseBlockActiveCaseSchedule({
              preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
              otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
            });
          } else {
            if (!props.isDashboard) {
              props.updateNewCaseScheduleData({
                preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
              });
            }
            if (props.isDashboard) {
              props.updateCaseSchedule({
                preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
              });
              if (!props.shoudlSaveCaseData) {
                props.setShouldSaveCaseData(true);
              }
            }
          }
        }}
      >
        <div className='ml-2'>
          <div>{preOpDxValue}</div>
        </div>
      </div>
    );
  }
  // Append search results
  if (Array.isArray(props.icd10CodesSearchResults) &&
    props.icd10CodesSearchResults.length > 0) {
    props.icd10CodesSearchResults.forEach((el) => {
      preOpDxSearchItems.push(
        <div
          key={el._id}
          className={`fx fx__v-center ${css(styles.menuItem)}`}
          onClick={(e) => {
            e.stopPropagation();
            setShowPreOpDxSearchMenu(false);
            setPreOpDxValue('');
            const tmpPreOp = {
              id: el._id,
              code: el.fullCode,
              description: el.abbreviatedDescription,
              npi: el.npi
            };
            setPreOpDx((prevState) => {
              if (prevState.findIndex(item => item.code === el.fullCode) < 0) {
                return prevState.concat(tmpPreOp);
              } else {
                return prevState;
              }
            });
            props.resetIcd10Search();
            const updatedPreOpDx = preOpDx.concat(tmpPreOp);
            if (props.forCaseBlocks) {
              props.updateCaseBlockActiveCaseSchedule({
                preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
              });
            } else {
              if (!props.isDashboard) {
                props.updateNewCaseScheduleData({
                  preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                  otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
                });
              }
              if (props.isDashboard) {
                props.updateCaseSchedule({
                  preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                  otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
                });
                if (!props.shoudlSaveCaseData) {
                  props.setShouldSaveCaseData(true);
                }
              }
            }
          }}
        >
          <div className='ml-2'>
            <div>{el.fullCode}</div>
            <div>
              {getHighlightedText(el.abbreviatedDescription, preOpDxValue)}
            </div>
          </div>
        </div>
      );
    });
  }

  // *** PostOp DX MENU ITEMS ***
  const postOpDxSearchItems = [];
  // Append search text
  if (postOpDxValue.length > 0) {
    postOpDxSearchItems.push(
      <div
        key='877891781postOp'
        className={`fx fx__v-center ${css(styles.menuItem)}`}
        style={{ height: '40px' }}
        onClick={(e) => {
          e.stopPropagation();
          const tmpDx = {
            id: Math.random().toString(36).slice(2),
            code: '',
            description: postOpDxValue,
            npi: 0
          };
          setShowPostOpDxSearchMenu(false);
          setPostOpDxValue('');
          setPostOpDx((prevState) => {
            return prevState.concat(tmpDx);
          });
          const updatedPostOpDx = postOpDx.concat(tmpDx);
          if (props.forCaseBlocks) {
            props.updateCaseBlockActiveCaseSchedule({
              postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
              otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
            });
            if (!props.shoudlSaveCaseData) {
              props.setShouldSaveCaseData(true);
            }
          } else {
            if (!props.isDashboard) {
              props.updateNewCaseScheduleData({
                postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                otherPostOpDx: updatedPostOpDx.filter(el => el.npi === 0)
              });
            }
            if (props.isDashboard) {
              props.updateCaseSchedule({
                postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                otherPostOpDx: updatedPostOpDx.filter(el => el.npi === 0)
              });
              if (!props.shoudlSaveCaseData) {
                props.setShouldSaveCaseData(true);
              }
            }
          }
        }}
      >
        <div className='ml-2'>
          <div>{postOpDxValue}</div>
        </div>
      </div>
    );
  }
  // Append search results
  if (Array.isArray(props.icd10CodesSearchResults) &&
    props.icd10CodesSearchResults.length > 0) {
    props.icd10CodesSearchResults.forEach((el) => {
      postOpDxSearchItems.push(
        <div
          key={el._id}
          className={`fx fx__v-center ${css(styles.menuItem)}`}
          onClick={(e) => {
            e.stopPropagation();
            setShowPostOpDxSearchMenu(false);
            setPostOpDxValue('');
            const tmpDx = {
              id: el._id,
              code: el.fullCode,
              description: el.abbreviatedDescription,
              npi: el.npi
            };
            setPostOpDx((prevState) => {
              if (prevState.findIndex(item => item.code === el.fullCode) < 0) {
                return prevState.concat(tmpDx);
              } else {
                return prevState;
              }
            });
            props.resetIcd10Search();
            const updatedPostOpDx = postOpDx.concat(tmpDx);
            if (props.forCaseBlocks) {
              props.updateCaseBlockActiveCaseSchedule({
                postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
              });
              if (!props.shoudlSaveCaseData) {
                props.setShouldSaveCaseData(true);
              }
            } else {
              if (!props.isDashboard) {
                props.updateNewCaseScheduleData({
                  postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                  otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
                });
              }
              if (props.isDashboard) {
                props.updateCaseSchedule({
                  postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                  otherPostOpDx: updatedPostOpDx.filter(el => el.npi === 0)
                });
                if (!props.shoudlSaveCaseData) {
                  props.setShouldSaveCaseData(true);
                }
              }
            }
          }}
        >
          <div className='ml-2'>
            <div>{el.fullCode}</div>
            {/* <div>{getHighlightedText(el.abbreviatedDescription, postOpDxValue)}</div> */}
            <div>{el.abbreviatedDescription}</div>
          </div>
        </div>
      );
    });
  }

  return (
    <>
      {/* --- Practice & Scheduler ---------------------------------------- */}
      <div className={`p-3 ${css(styles.practiceInfoContainer)}`}>
        {/* Case created by user and case creation date */}
        <div className='font-12__bold'>
          Case posted {getWeekDay(caseCreationDate.getDay())} {getMonthName(caseCreationDate.getMonth())}{caseCreationDate.getDate()}, {caseCreationDate.getFullYear()}  @ {caseCreationDate.getHours()}:{caseCreationDate.getMinutes()} By @{caseUserName}
        </div>
        {/* Practice related to case */}
        <div className='font-12__bold'>
          {practice && practice.displayName && practice.displayName}
        </div>
      </div>

      {/* --- TF | TBD ---------------------------------------------------- */}
      <div className={`pl-2 pr-2 pb-2 mt-2 ${css(styles.formField)}`}>
        {/* Schedule Time Warning */}
        {showScheduleTimeCriticalWarning
          ? <CriticalWarningIcon height={12} />
          : <SuccessIcon height={14} />
        }
        <div className='ml-2 fx fx__v-center fx__align-spacebetween'>
          {/* Title */}
          <div className='font-14__bold'>Schedule Date/Time</div>
          {/* To Follow / TBD - Checkboxes */}
          {/* Temporarily disbaled - until Tony makes a decision about how to handle TF / TBD (01-23-24) */}
          <div className='fx ml-2 pr-2 d-none'>
            <Checkbox
              text='TF'
              height={16}
              width={16}
              isChecked={isScheduleTimeTF}
              onChange={handleOnChangeScheduleTimeTF}
            />
            {/* TBD - Checkbox */}
            <div className='ml-2'>
              <Checkbox
                text='TBD'
                isChecked={isDosTbd}
                height={16}
                width={16}
                onChange={handleOnChangeTBD}
              />
            </div>
          </div>
        </div>
      </div>

      {/* --- Scheduled Start Time ---------------------------------------- */}
      <div className={`pl-2 pr-2 pt-1 pb-1 ${css(styles.formField)}`}>
        {/* Icon */}
        {isScheduleStartTimePristine
          ? <CriticalWarningIcon height={12} />
          : <SuccessIcon height={14} />
        }
        <div
          className={`ml-2 pt-1 fx fx__v-baseline ${css(styles.formFieldTimePicker)}`}
          style={{ display: isScheduleTimeTF ? 'none' : '' }}
        >
          {/* Label */}
          <div className='font-14__bold' style={{ minWidth: '32px' }}>
            Start
          </div>
          <div
            className={`font-14__bold ml-2 ${css(styles.weekDayName)}`}
            style={{ display: isScheduleStartDatePristine ? 'none' : '' }}
          >
            {getShortWeekDay((new Date(scheduleStartYear, scheduleStartMonth, scheduleStartDate)).getDay())}
          </div>
          {/* Start date */}
          <DatePicker
            left={-65}
            right={0}
            date={scheduleStartDate}
            month={scheduleStartMonth}
            year={scheduleStartYear}
            isPrisitine={isScheduleStartDatePristine}
            color={isScheduleStartDatePristine ? yellow[500] : blue[500]}
            noUnderline
            readOnlyMode={isDosTbd}
            className={`ml-2 font-14__bold ${css(isDosTbd && styles.disabled)}`}
            onChangeDate={handleOnChangeScheduleStartDate}
          />
          {/* Start time */}
          <div className={`ml-2 ${css(styles.formFieldTimePicker)}`}>
            <TimePicker
              className='pl-1 pr-2 font-14__bold'
              hour={scheduleStartHour}
              minute={scheduleStartMinute}
              color={!props.isDashboard && isScheduleStartTimePristine ? yellow[500] : blue[500]}
              noUnderline
              timeFormat='24H'
              timePeriod='AM'
              isPristine={isScheduleStartTimePristine}
              onChangeTime={handleOnChangeScheduleStartTime}
              disableTimeFormat
            />
          </div>
        </div>
      </div>

      {/* --- Scheduled End Time ------------------------------------------ */}
      <div className={`pl-2 pr-2 pt-1 pb-1 ${css(styles.formField, styles.lightBorderBottom)}`}>
        {/* Icon */}
        {showEndDateCriticalWarning
          ? <CriticalWarningIcon height={12} />
          : <SuccessIcon height={14} />
        }
        <div
          className={`pt-1 ml-2 fx fx__v-baseline ${css(styles.formFieldTimePicker)}`}
          style={{ display: isScheduleTimeTF ? 'none' : '' }}
        >
          {/* Label */}
          <div className='font-14__bold' style={{ minWidth: '32px' }}>Stop</div>
          <div
            className={`font-14__bold ml-2 ${css(styles.weekDayName)}`}
            style={{ display: isScheduleEndDatePristine ? 'none' : '' }}
          >
            {getShortWeekDay((new Date(scheduleEndYear, scheduleEndMonth, scheduleEndDate)).getDay())}
          </div>
          <DatePicker
            left={-65}
            right={2}
            date={scheduleEndDate}
            month={scheduleEndMonth}
            year={scheduleEndYear}
            isPrisitine={isScheduleEndDatePristine}
            color={isScheduleEndDatePristine ? yellow[500] : blue[500]}
            noUnderline
            readOnlyMode={isDosTbd}
            className={`ml-2 font-14__bold ${css(isDosTbd && styles.disabled)}`}
            onChangeDate={handleOnChangeScheduleEndDate}
          />
          {/* End Time - TimePicker */}
          <div className={`ml-2 ${css(styles.formFieldTimePicker)}`}>
            <TimePicker
              className='pl-1 pr-2 font-14__bold'
              hour={scheduleEndHour}
              minute={scheduleEndMinute}
              color={!props.isDashboard && isScheduleEndTimePristine ? yellow[500] : blue[500]}
              noUnderline
              timeFormat='24H'
              timePeriod='AM'
              isPristine={isScheduleEndTimePristine}
              onChangeTime={handleOnChangeScheduleEndTime}
              disableTimeFormat
            />
          </div>
        </div>
      </div>

      {/* --- Patient Type ------------------------------------------------ */}
      <div className={`p-2 mt-0 ${css(styles.formField, styles.lightBorderBottom)}`}>
        {/* Icon */}
        {props.isDashboard
          ? patientType.length === 0 ? <CriticalWarningIcon height={16} /> : <SuccessIcon height={18} />
          : patientType.length === 0 ? <WarningIcon height={18} /> : <SuccessIcon height={18} />
        }
        {/* Label */}
        <div className='ml-2 font-14__bold'>Admission Type</div>
        {/* Admission Type selection */}
        <div
          className='ml-2 fx'
          style={{
            border: `1px solid ${gray[400]}`,
            borderRadius: '4px',
            padding: '2px'
          }}
        >
          {/* Out Patient */}
          <PressedButton
            width={45}
            height={32}
            className={css(
              styles.pressedBtn,
              styles.admissionTypeBtn,
              !props.isDashboard && patientType.length === 0 && styles.pressedBtnWarning,
              props.isDashboard && patientType.length === 0 && styles.pressedBtnCritical
            )}
            style={{ height: '22px' }}
            isPressed={patientType === PATIENT_TYPE.OUT}
            onClick={handleOnClickOutPt}
          >
            Out Pt
          </PressedButton>
          {/* In Patient */}
          <PressedButton
            width={45}
            height={32}
            className={`ml-1 ${css(
              styles.pressedBtn,
              styles.admissionTypeBtn,
              !props.isDashboard && patientType.length === 0 && styles.pressedBtnWarning,
              props.isDashboard && patientType.length === 0 && styles.pressedBtnCritical
            )}`}
            style={{ height: '22px' }}
            isPressed={patientType === PATIENT_TYPE.IN}
            onClick={handleOnClickInPt}
          >
            In Pt
          </PressedButton>
        </div>
      </div>

      {/* --- Facility ---------------------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <CaseField
          heading='Facility'
          showSearchIcon
          showAlert={showFacilityCriticalWarning}
          showIncomplete={!showFacilityCriticalWarning && showFacilityWarning}
          showPlusIcon={false}
        />
        {/* Facility value textbox & search menu */}
        <div
          ref={facilitySearchMenuRef}
          className={`mt-0 ${css(styles.searchFormFieldTextboxContainer)}`}
          style={{ display: (facility && Object.keys(facility).length > 0) ? 'none' : '' }}
        >
          <TextInput
            value={facilityValue}
            placeholder="Search Facility"
            style={{
              width: `${DRAWER_WIDTH - 21}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onChange={(e) => {
              const { value } = e.target;
              setFacilityValue(value);
            }}
            onClick={() => {
              setShowFacilitySearchMenu(true);
            }}
          />
          {showFacilitySearchMenu &&
            <PopupMenu
              top={35}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showFacilitySearchMenu}
              parent={facilitySearchMenuRef}
              onOutsideClick={() => { setShowFacilitySearchMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                {/* Search message for user */}
                {props.facilitySearchResults.length === 0 &&
                  <div className={css(styles.searchPopupMenuPlaceholder)}>
                    {props.searchingFacilities && 'Searching facilities...'}
                    {!props.searchingFacilities && props.facilitySearchResults.length === 0 && facilityValue.length === 0 &&
                      'Search Facility in the text box above'
                    }
                    {!props.searchingFacilities && props.facilitySearchResults.length === 0 && facilityValue.length !== 0 &&
                      'No facilities found!'
                    }
                  </div>
                }
                {/* Facility search menu items */}
                {props.facilitySearchResults.length > 0 &&
                  props.facilitySearchResults.map((el) => {
                    return (
                      <div
                        className={`fx fx__v-center ${css(styles.menuItem)}`}
                        key={el._id}
                        onClick={() => {
                          setShowFacilitySearchMenu(false);
                          setFacilityValue('');
                          const tmpFacility = {
                            id: el._id,
                            facility: el._id,
                            facilityDisplayName: el.displayName,
                            facilityName: el.facilityName,
                            facilityUserName: el.userName,
                            npi: el.npi,
                            text: `${el.facilityName}`,
                            icon: el.avatarImageUrl,
                            user: el._id,
                            fullName: el.facilityName,
                            taxonomy: el.taxonomy,
                            locations: el.locations
                          };
                          setFacility(tmpFacility);
                          props.resetFacilitySearch();
                          if (props.forCaseBlocks) {
                            props.updateCaseBlockActiveCaseSchedule({ facility: tmpFacility });
                            if (!props.shoudlSaveCaseData) {
                              props.setShouldSaveCaseData(true);
                            }
                          } else {
                            if (!props.isDashboard) {
                              props.updateNewCaseScheduleData({ facility: tmpFacility });
                            } else {
                              props.updateCaseSchedule({ facility: tmpFacility });
                              if (!props.shoudlSaveCaseData) {
                                props.setShouldSaveCaseData(true);
                              }
                            }
                          }
                        }}
                      >
                        {/* Avatar */}
                        <div className={css(styles.menuItemAvatarContainer)}>
                          <img
                            src={el.avatarImageUrl}
                            alt='Facility Avatar'
                            className={css(styles.menuItemAvatarImg)}
                          />
                        </div>
                        {/* Facility Name */}
                        <div className='ml-2'>
                          <div>{getHighlightedText(el.displayName, facilityValue)}</div>
                          {/* <div>{el.taxonomy}</div> */}
                          <div>{`@${el.userName}`}</div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </PopupMenu>
          }
        </div>
        {/* Selected facility card */}
        {Object.keys(facility).length > 0 &&
          <FacilityLocationCard
            key={`${facility._id}__facility`}
            data={facility}
            selectedLocation={selectedFacilityLocation}
            msgColor={props.isDashboard ? yellow[500] : salmon[500]}
            locations={props.isDashboard
              ? facility.locations.concat('Other')
              : facility.locations
            }
            onSelectLocation={handelOnSelectFacilityLocation}
            onDeleteFacility={handleOnDeleteFacility}
          />
        }
      </div>

      {/* --- Surgeon ----------------------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <div
          className='fx fx__v-center'
          style={{ justifyContent: 'space-between' }}
        >
          <CaseField
            heading='Surgeons'
            showAlert={showSurgeonCriticalWarning}
            showIncomplete={false}
            showNoneFlag={false}
            showSearchIcon
            showPlusIcon={false}
          />
        </div>
        {/* Surgeon value textbox & search menu */}
        <div
          ref={surgeonSearchMenuRef}
          className={`mt-0 ${css(styles.searchFormFieldTextboxContainer)}`}
        >
          <TextInput
            value={surgeonValue}
            placeholder="Search Practices/Providers"
            style={{
              width: `${DRAWER_WIDTH - 21}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onClick={() => {
              setShowSurgeonsSearchMenu(true);
            }}
            onChange={(e) => {
              const { value } = e.target;
              setSurgeonValue(value);
            }}
          />
          {showSurgeonsSearchMenu &&
            <PopupMenu
              top={35}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showSurgeonsSearchMenu}
              parent={surgeonSearchMenuRef}
              onOutsideClick={() => { setShowSurgeonsSearchMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                {props.surgeonsSearchResults.length === 0 &&
                  <div className={css(styles.searchPopupMenuPlaceholder)}>
                    {/* {surgeonSearchMsg} */}
                    {props.searchingSurgeons && 'Searching surgeons...'}
                    {!props.searchingSurgeons && props.surgeonsSearchResults.length === 0 && surgeonValue.length === 0 &&
                      'Search surgeon in the text box above'
                    }
                    {!props.searchingSurgeons && props.surgeonsSearchResults.length === 0 && surgeonValue.length !== 0 &&
                      'No surgeons found!'
                    }
                  </div>
                }
                {surgeonSearchPractices.length > 0 &&
                  <div className={`pl-2 fx fx__v-center ${css(styles.suggResults)}`}>
                    Suggested Results
                  </div>
                }
                {/* Practices */}
                {Array.isArray(surgeonSearchPractices) && surgeonSearchPractices.length > 0 &&
                  surgeonSearchPractices.map((el) => (
                    <div
                      key={el._id}
                      className={`fx fx__v-center ${css(styles.menuItem)}`}
                      style={{ height: '40px' }}
                      onClick={() => {
                        let updatedSurgeonPractices = clone(surgeonPractices);
                        updatedSurgeonPractices = updatedSurgeonPractices.concat({
                          ...el,
                          addedProviders: []
                        });
                        setShowSurgeonsSearchMenu(false);
                        setSurgeonValue('');
                        setSurgeonPractices((prevState) => {
                          if (prevState.findIndex(item => item._id === el._id) < 0) {
                            return prevState.concat({
                              ...el,
                              addedProviders: []
                            });
                          } else {
                            debugLogToConsole('Practice entry already exists!');
                            return prevState;
                          }
                        });
                      }}
                    >
                      {getHighlightedText(el.practiceName, surgeonValue)}
                    </div>
                  ))
                }
                {/* Providers */}
                {props.surgeonsSearchResults.length > 0 &&
                  props.surgeonsSearchResults.map((el) => {
                    return (
                      <div
                        key={el._id}
                        className={`fx fx__v-center ${css(styles.menuItem)}`}
                        style={{ height: '40px' }}
                        onClick={() => {
                          setShowSurgeonsSearchMenu(false);
                          setSurgeonValue('');
                          const newSurgeon = {
                            id: el._id,
                            text: `${el.displayName}`,
                            icon: el.avatarImageUrl,
                            avatarImageUrl: el.avatarImageUrl,
                            user: el._id,
                            fullName: `${el.lastName}, ${el.firstName}`,
                            npi: el.npi,
                            caseRelation: el.taxonomy ? el.taxonomy.coloquial || el.taxonomy.desc : el.specialty,
                            credentials: el.credentials,
                            addedPractices: []
                          };

                          // Duplicate surgeon check
                          const surgeonDuplicateIndex = surgeons.findIndex((surg) => {
                            return surg.npi === el.npi;
                          });
                          if (surgeonDuplicateIndex < 0) {
                            setSurgeons((prevState) => {
                              if (prevState.findIndex(item => item.user === el._id) < 0) {
                                return prevState.concat(newSurgeon);
                              } else {
                                debugLogToConsole('Surgeon entry already exists!');
                                return prevState;
                              }
                            });
                            if (props.forCaseBlocks) {
                              props.updateCaseBlockActiveCaseSchedule({
                                surgeons: surgeons.concat(newSurgeon)
                              });
                              if (!props.shoudlSaveCaseData) {
                                props.setShouldSaveCaseData(true);
                              }
                            } else {
                              if (!props.isDashboard) {
                                props.updateNewCaseScheduleData({ surgeons: surgeons.concat(newSurgeon) });
                              } else {
                                props.updateCaseSchedule({ surgeons: surgeons.concat(newSurgeon) });
                                if (!props.shoudlSaveCaseData) {
                                  props.setShouldSaveCaseData(true);
                                }
                              }
                            }
                          }
                          props.resetSurgeonSearch();
                        }}
                      >
                        <div className='fx fx__v-center'>
                          <img
                            src={el.avatarImageUrl}
                            className={css(styles.menuItemAvatarImg)}
                          />
                          <div className='ml-2'>
                            {getHighlightedText(`${el.displayName}, ${el.credentials}`, surgeonValue)}
                            <div>
                              {el.specialty}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </PopupMenu>
          }
        </div>
        {/* Surgeon Practice Card */}
        {surgeonPractices && surgeonPractices.length > 0 &&
          surgeonPractices.map((el, idx) => (
            <PracticeProviderCard
              key={`${el._id}__practice_surgeon`}
              data={el}
              placeholderMsg='Search Surgeons'
              isDashboard={props.isDashboard}
              searchRoute='searchMedProsSurgeons'
              warningText='You must add at least 1 surgeon'
              index={idx}
              onAddProvider={(data, index) => {
                const updatedSurgeonPractices = clone(surgeonPractices);
                let tmp = clone(updatedSurgeonPractices[index].addedProviders);
                tmp = tmp.concat(data);
                updatedSurgeonPractices[index].addedProviders = tmp;
                setSurgeonPractices(updatedSurgeonPractices);
              }}
              onDeleteProvider={(practiceIndex, userId) => {
                const updatedSurgeonPractices = clone(surgeonPractices);
                let tmp = clone(updatedSurgeonPractices[practiceIndex].addedProviders);
                tmp = tmp.filter((el) => {
                  return el._id !== userId;
                });
                updatedSurgeonPractices[practiceIndex].addedProviders = tmp;
                window.sp = updatedSurgeonPractices;
                setSurgeonPractices(updatedSurgeonPractices);
              }}
              onDeletePractice={(index) => {
                const updatedSurgeonPractices = clone(surgeonPractices);
                updatedSurgeonPractices.splice(index, 1);
                let tmpProviders = [];
                surgeonPractices.forEach(practice => {
                  tmpProviders = tmpProviders.concat(practice.addedProviders);
                });
                props.onUpdatePatientCard('surgeons', tmpProviders);
                setSurgeonPractices(updatedSurgeonPractices);
              }}
            />
          ))
        }
        {/* Surgeons cards */}
        {surgeons && Array.isArray(surgeons) && surgeons.length > 0 &&
          surgeons.map((surgeon, idx) => (
            <ProviderPracticeCard
              key={`${surgeon._id || surgeon.id || surgeon.npi}__surgeon_practice___${idx}`}
              data={surgeon}
              placeholderMsg='Search Practices'
              isDashboard={props.isDashboard}
              warningText='You must add at least 1 practice'
              index={idx}
              showPractice={false}
              showStartStopTimes={false}
              onAddPractice={(data, index) => {
                const updatedSurgeonsList = clone(surgeons);
                let tmp = clone(updatedSurgeonsList[index].addedPractices);
                tmp = [].concat(data);
                updatedSurgeonsList[index].addedPractices = tmp;
                setSurgeons(updatedSurgeonsList);
              }}
              onDeletePractice={(practiceIndex, userId) => {
                debugLogToConsole('Practice Deleted!');
              }}
              onDeleteProvider={(index) => {
                const updatedSurgeonsList = clone(surgeons);
                updatedSurgeonsList.splice(index, 1);
                const tmpProviders = [];
                updatedSurgeonsList.forEach(el => {
                  tmpProviders.push({ fullName: el.fullName });
                });
                setSurgeons(updatedSurgeonsList);
                if (props.forCaseBlocks) {
                  props.updateCaseBlockActiveCaseSchedule({
                    surgeons: updatedSurgeonsList
                  });
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({
                      surgeons: updatedSurgeonsList
                    });
                  } else {
                    props.updateCaseSchedule({
                      surgeons: updatedSurgeonsList
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }
              }}
            />
          ))
        }
      </div>

      {/* --- Surgical Procedures ----------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <CaseField
          heading='Procedures'
          // searchText='CPT'
          showSearchIcon
          showAlert={showSurgicalProceduresCriticalWarning}
          showIncomplete={showSurgicalProceduresWarning}
          showPlusIcon={false}
        />
        {/* <textarea
          className={css(styles.fieldTextArea)}
        /> */}
        {surgicalProcedures.length > 0 && (surgicalProcedures.filter(el => el.npi === 0)).length > 0 && (surgicalProcedures.filter(el => el.npi === 0)).length === surgicalProcedures.length &&
          <div
            className='pl-1 mt-2 mb-2'
            style={{
              color: salmon[500],
              fontSize: '12px',
              opacity: '0.5'
            }}
          >
            Add atleast 1 valid CPT code
          </div>
        }
        {surgicalProcedures.length === 0 &&
          <div
            className='pl-1 mt-2 mb-2'
            style={{ color: yellow[500], fontSize: '12px', opacity: '0.5' }}
          >
            Add description OR at least 1 valid CPT code
          </div>
        }
        {/* Surgical procedure value textbox & search menu */}
        <div
          ref={procedureSearchMenuRef}
          className='mt-0'
          style={{
            border: `1px solid ${blue[700]}`,
            borderRadius: '4px',
            position: 'relative'
          }}
        >
          <TextInput
            value={procedureValue}
            placeholder="Search Surgical Procedure(s)"
            style={{
              width: `${DRAWER_WIDTH - 21}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onChange={(e) => {
              const { value } = e.target;
              setProcedureValue(value);
            }}
            onClick={() => {
              setShowProceduresSearchMenu(true);
            }}
          />
          {showProceduresSearchMenu &&
            <PopupMenu
              top={35}
              left={0}
              zIndex='1550'
              position="absolute"
              visible={showProceduresSearchMenu}
              parent={procedureSearchMenuRef}
              onOutsideClick={() => { setShowProceduresSearchMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                {procedureSearchItems.length > 0 &&
                  <div className={`pl-2 fx fx__v-center ${css(styles.suggResults)}`}>
                    Suggested Results
                  </div>
                }
                {procedureSearchItems}
              </div>
            </PopupMenu>
          }
        </div>

        {/* Surgical Procedures Cards */}
        {surgicalProcedures.map(dx => {
          return (
            <CaseUserCard
              className='mt-1'
              avatarImageUrl={null}
              showCloseIcon
              showAlert={false}
              noAvatar
              key={`${dx.id || dx._id}__surg_proc`}
              dataId={dx.id || dx._id}
              onClose={(id) => {
                const updatedSurgicalProcedures = surgicalProcedures.filter((el) => {
                  if (el.id) {
                    return el.id !== id;
                  }
                  return el._id !== id;
                });
                setSurgicalProcedures(updatedSurgicalProcedures);
                if (props.forCaseBlocks) {
                  props.updateCaseBlockActiveCaseSchedule({
                    surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                    otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
                  });
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({
                      surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                      otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
                    });
                  }

                  if (props.isDashboard) {
                    props.updateCaseSchedule({
                      surgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi !== 0),
                      otherSurgicalProcedures: updatedSurgicalProcedures.filter(el => el.npi === 0)
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }
              }}
            >
              <div style={{ fontSize: '12px', marginLeft: '8px' }}>
                <div>
                  {/* {`${dx.npi === 0 ? '?CPT:' : ''} ${dx.description} ${dx.code !== 'N/A' ? `(${dx.code})` : ''}`} */}
                  {`${dx.description} ${dx.code.length > 0 ? `(${dx.code})` : ''}`}
                </div>
              </div>
            </CaseUserCard>
          );
        })}
      </div>

      {/* --- PreOp DX ---------------------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <div
          className='fx fx__v-center'
          style={{ justifyContent: 'space-between' }}
        >
          <CaseField
            heading='PreOp Dx'
            showSearchIcon
            showAlert={showPreOpDxCriticalWarning}
            showIncomplete={showPreOpDxWarning}
            showPlusIcon={false}
            style={{ flexGrow: '1' }}
          />
          <div
            className='pr-2'
            style={{
              display: props.isDashboard ? 'none' : '',
              marginBottom: '1px'
            }}
          >
            <Checkbox
              text='Skip'
              isChecked={isSkipPreOpDx}
              onChange={hanldeOnChangeSkipPreOpDx}
            />
          </div>
        </div>
        {/* Info message */}
        {preOpDx.length === 0 && !isSkipPreOpDx &&
          <div
            className='pl-1 mt-2 mb-2'
            style={{ color: yellow[500], fontSize: '12px', opacity: '0.5' }}
          >
            Add description OR at least 1 valid ICD10 code
          </div>
        }
        {/* Warning message */}
        {showPreOpDxWarningMessage && !isSkipPreOpDx &&
          <div
            className='pl-1 mt-2 mb-2'
            style={{ color: salmon[500], fontSize: '12px', opacity: '0.5' }}
          >
            Add at least 1 valid ICD-10 code
          </div>
        }
        {/* PreOp Dx value textbox & search menu */}
        {!(isSkipPreOpDx && !props.isDashboard) &&
          <div
            ref={preOpDxSearchMenuRef}
            className='mt-0'
            style={{
              border: `1px solid ${blue[700]}`,
              borderRadius: '4px',
              position: 'relative'
            }}
          >
            <TextInput
              value={preOpDxValue}
              placeholder="Search PreOp Dx OR ICD10 codes"
              style={{
                width: `${DRAWER_WIDTH - 21}px`,
                fontSize: '14px',
                padding: '0 4px',
                color: blue[200],
                borderRadius: '4px'
              }}
              onChange={(e) => {
                const { value } = e.target;
                setPreOpDxValue(value);
              }}
              onClick={() => setShowPreOpDxSearchMenu(true)}
            />
            {showPreOpDxSearchMenu &&
              <PopupMenu
                top={35}
                left={0}
                zIndex='1550'
                position="absolute"
                visible={showPreOpDxSearchMenu}
                parent={preOpDxSearchMenuRef}
                onOutsideClick={() => { setShowPreOpDxSearchMenu(false); }}
              >
                <div className={css(styles.searchPopupMenuContainer)}>
                  {/* Search message for user */}
                  {Array.isArray(props.icd10CodesSearchResults) &&
                    props.icd10CodesSearchResults.length === 0 &&
                    <div className={css(styles.searchPopupMenuPlaceholder)}>
                      {props.searchingIcd10 && 'Searching PreOpDx...'}
                      {!props.searchingIcd10 && props.icd10CodesSearchResults.length === 0 && preOpDxValue.length === 0 &&
                        'Search ICD10 code in the text box above'
                      }
                      {!props.searchingIcd10 && props.icd10CodesSearchResults.length === 0 && preOpDxValue.length !== 0 &&
                        'No ICD10 code found!'
                      }
                    </div>
                  }
                  {preOpDxSearchItems}
                </div>
              </PopupMenu>
            }
          </div>
        }
        {/* PreOpDx Cards */}
        {preOpDx.map(dx => {
          return (
            <CaseUserCard
              className='mt-1'
              avatarImageUrl={null}
              showCloseIcon
              showAlert={false}
              noAvatar
              key={`${dx.id || dx._id}__preop_dx`}
              dataId={dx.id || dx._id}
              onClose={(id) => {
                const updatedPreOpDx = preOpDx.filter((el) => {
                  if (el.id) {
                    return el.id !== id;
                  }
                  return el._id !== id;
                });
                setPreOpDx(updatedPreOpDx);
                if (props.forCaseBlocks) {
                  props.updateCaseBlockActiveCaseSchedule({
                    preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                    otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
                  });
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard && preOpDx.length > 0) {
                    props.updateNewCaseScheduleData({
                      preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                      otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
                    });
                  }
                  if (props.isDashboard && preOpDx.length > 0) {
                    props.updateCaseSchedule({
                      preOpDx: updatedPreOpDx.filter(el => el.npi !== 0),
                      otherPreOpDx: updatedPreOpDx.filter(el => el.npi === 0)
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }
              }}
            >
              <div style={{ fontSize: '12px', marginLeft: '8px' }}>
                <div>
                  {/* {`${dx.npi === 0 ? '?ICD10:' : ''} ${dx.description} ${dx.code.length > 0 ? `(${dx.code})` : ''}`} */}
                  {`${dx.description} ${dx.code.length > 0 ? `(${dx.code})` : ''}`}
                </div>
              </div>
            </CaseUserCard>
          );
        })}
      </div>

      {/* --- PostOp DX --------------------------------------------------- */}
      {props.isDashboard &&
        <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
          <div
            className='fx'
            style={{
              justifyContent: 'space-between',
              alignItems: 'flex-end'
            }}
          >
            <CaseField
              heading='PostOp Dx'
              showSearchIcon
              showAlert={showPostOpDxCriticalWarning}
              showIncomplete={showPostOpDxWarning}
              showPlusIcon={false}
              style={{ flexGrow: '1' }}
            />
            <div className='pr-2' style={{ marginBottom: '1px' }}>
              <Checkbox
                text='Same As PreOpDx'
                isChecked={isSameAsPreOpDx}
                onChange={hanldeOnChangeSameAsPreOpDx}
              />
            </div>
          </div>
          {/* Info message */}
          {postOpDx.length === 0 && !isSameAsPreOpDx &&
            <div
              className='pl-1 mt-2 mb-2'
              style={{ color: yellow[500], fontSize: '12px', opacity: '0.5' }}
            >
              Add description OR at least 1 valid ICD10 code
            </div>
          }
          {/* Warning message */}
          {showPostOpDxWarningMessage && !isSameAsPreOpDx &&
            <div
              className='pl-1 mt-2 mb-2'
              style={{ color: salmon[500], fontSize: '12px', opacity: '0.5' }}
            >
              Add at least 1 valid ICD-10 code
            </div>
          }
          {/* PostOp Dx value textbox & search menu */}
          <div
            ref={postOpDxSearchMenuRef}
            className='mt-0'
            style={{
              border: `1px solid ${blue[700]}`,
              borderRadius: '4px',
              position: 'relative',
              display: isSameAsPreOpDx ? 'none' : ''
            }}
          >
            <TextInput
              value={postOpDxValue}
              placeholder="Search PostOp Dx OR ICD10 codes"
              disabled={isSameAsPreOpDx}
              style={{
                width: `${DRAWER_WIDTH - 21}px`,
                fontSize: '14px',
                padding: '0 4px',
                color: blue[200],
                borderRadius: '4px'
              }}
              onChange={(e) => {
                const { value } = e.target;
                setPostOpDxValue(value);
              }}
              onClick={() => setShowPostOpDxSearchMenu(true)}
            />
            {showPostOpDxSearchMenu &&
              <PopupMenu
                top={35}
                left={0}
                zIndex='1550'
                position="absolute"
                visible={showPostOpDxSearchMenu}
                parent={preOpDxSearchMenuRef}
                onOutsideClick={() => { setShowPostOpDxSearchMenu(false); }}
              >
                <div className={css(styles.searchPopupMenuContainer)}>
                  {/* Search message for user */}
                  {props.icd10CodesSearchResults.length === 0 &&
                    <div className={css(styles.searchPopupMenuPlaceholder)}>
                      {props.searchingIcd10 && 'Searching PostOpDx...'}
                      {!props.searchingIcd10 && props.icd10CodesSearchResults.length === 0 && preOpDxValue.length === 0 &&
                        'Search ICD10 code in the text box above'
                      }
                      {!props.searchingIcd10 && props.icd10CodesSearchResults.length === 0 && preOpDxValue.length !== 0 &&
                        'No ICD10 code found!'
                      }
                    </div>
                  }
                  {postOpDxSearchItems}
                </div>
              </PopupMenu>
            }
          </div>
          {/* PostOpDx Cards */}
          {postOpDx.map(dx => {
            return (
              <CaseUserCard
                className='mt-1'
                avatarImageUrl={null}
                showCloseIcon
                showAlert={false}
                noAvatar
                key={dx.id || dx._id}
                dataId={dx.id || dx._id}
                onClose={(id) => {
                  const updatedPostOpDx = postOpDx.filter(el => {
                    if (el.id) {
                      return el.id !== id;
                    }
                    return el._id !== id;
                  });
                  setPostOpDx(updatedPostOpDx);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                      otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({
                        postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                        otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
                      });
                    }
                    if (props.isDashboard) {
                      props.updateCaseSchedule({
                        postOpDx: updatedPostOpDx.filter(el => el.npi !== 0),
                        otherPostOpDx: updatedPostOpDx.filter(el => el.npi !== 0)
                      });
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }
                }}
              >
                <div style={{ fontSize: '12px', marginLeft: '8px' }}>
                  <div>
                    {/* {`${dx.npi === 0 ? '?ICD10:' : ''} ${dx.description} ${dx.code.length > 0 ? `(${dx.code})` : ''}`} */}
                    {`${dx.description} ${dx.code.length > 0 ? `(${dx.code})` : ''}`}
                  </div>
                </div>
              </CaseUserCard>
            );
          })}
        </div>
      }

      {/* --- Anesthesiologists ------------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <div
          className='fx fx__v-center'
          style={{ justifyContent: 'space-between' }}
        >
          <CaseField
            heading='Anesthesiologists'
            showSearchIcon
            showAlert={showAnesthesiologistCriticalWarning}
            showIncomplete={showAnesthesiologistWarning}
            showNoneFlag={showAnesthesiologistNoneFlag}
            showPlusIcon={false}
          />
          <div className='pr-2' style={{ marginBottom: '1px' }}>
            <Checkbox
              text='None'
              isChecked={isNoneAnesthesiologist}
              onChange={handleOnChangeIsNoneAnesthesiologist}
            />
          </div>
        </div>
        {/* Anesthesiologist value textbox & search menu */}
        <div
          ref={anesthesiologistSearchMenuRef}
          className={`mt-0 ${css(styles.searchFormFieldTextboxContainer)}`}
          style={{
            display: isNoneAnesthesiologist ? 'none' : ''
          }}
        >
          <TextInput
            value={anesthesiologistValue}
            disabled={isNoneAnesthesiologist}
            placeholder="Search Practices/Providers"
            style={{
              width: `${DRAWER_WIDTH - 21}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onChange={(e) => {
              const { value } = e.target;
              setAnesthesiologistValue(value);
            }}
            onClick={() => setShowAnesthesiologistsSearchMenu(true)}
          />
          {showAnesthesiologistsSearchMenu &&
            <PopupMenu
              top={35}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showAnesthesiologistsSearchMenu}
              parent={anesthesiologistSearchMenuRef}
              onOutsideClick={() => { setShowAnesthesiologistsSearchMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                {Array.isArray(props.anesthesiologistsSearchResults) &&
                  props.anesthesiologistsSearchResults.length === 0 &&
                  <div className={css(styles.searchPopupMenuPlaceholder)}>
                    {props.searchingAnesthesiologists && 'Searching anesthesiologists...'}
                    {!props.searchingAnesthesiologists && anesthesiologistValue.length === 0 &&
                      'Search anesthesiologist in the text box above'
                    }
                    {!props.searchingAnesthesiologists && anesthesiologistValue.length !== 0 &&
                      'No anesthesiologist found!'
                    }
                  </div>
                }
                {/* Providers */}
                {Array.isArray(props.anesthesiologistsSearchResults) && props.anesthesiologistsSearchResults.length > 0 &&
                  props.anesthesiologistsSearchResults.map((el) => (
                    <div
                      key={el._id}
                      className={`fx fx__v-center ${css(styles.menuItem)}`}
                      style={{ height: '40px' }}
                      onClick={() => {
                        setShowAnesthesiologistsSearchMenu(false);
                        setAnesthesiologistValue('');
                        const tmpAnes = {
                          id: el._id,
                          text: `${el.displayName}`,
                          icon: el.avatarImageUrl,
                          avatarImageUrl: el.avatarImageUrl,
                          user: el._id,
                          fullName: `${el.lastName}, ${el.firstName}`,
                          npi: el.npi,
                          caseRelation: el.taxonomy ? el.taxonomy.coloquial || el.taxonomy.desc : el.specialty,
                          credentials: el.credentials,
                          addedPractices: [],
                          startType: 'anesStart',
                          startFlag: FLAG_VALUE.success,
                          startDate: scheduleStartDate,
                          startMonth: scheduleStartMonth,
                          startYear: scheduleStartYear,
                          startHour: '',
                          startMinute: '',
                          stopType: 'anesStop',
                          stopFlag: FLAG_VALUE.success,
                          stopDate: scheduleStartDate,
                          stopMonth: scheduleStartMonth,
                          stopYear: scheduleStartYear,
                          stopHour: '',
                          stopMinute: ''
                        };

                        // Check for duplicate ansesthesiologist
                        const duplicateAnesthesiologistIndex = anesthesiologists.findIndex((anes) => {
                          return anes.npi === el.npi
                        });

                        if (duplicateAnesthesiologistIndex < 0) {
                          setAnesthesiologists((prevState) => {
                            if (prevState.findIndex(item => item.user === el._id) < 0) {
                              return prevState.concat(tmpAnes);
                            } else {
                              debugLogToConsole('Anesthesiologist entry already exists!');
                              return prevState;
                            }
                          });

                          const updatedAnes = anesthesiologists.concat(tmpAnes);
                          if (props.forCaseBlocks) {
                            props.updateCaseBlockActiveCaseSchedule({
                              anesthesiologists: updatedAnes
                            });
                            if (!props.shoudlSaveCaseData) {
                              props.setShouldSaveCaseData(true);
                            }
                          } else {
                            if (!props.isDashboard) {
                              props.updateNewCaseScheduleData({ anesthesiologists: updatedAnes });
                            } else {
                              props.updateCaseSchedule({ anesthesiologists: updatedAnes });
                              if (!props.shoudlSaveCaseData) {
                                props.setShouldSaveCaseData(true);
                              }
                            }
                          }
                        }

                        props.resetAnesthesiologistSearch();
                      }}
                    >
                      <div className='fx fx__v-center'>
                        <img
                          src={el.avatarImageUrl}
                          className={css(styles.menuItemAvatarImg)}
                        />
                        <div className={`ml-2 ${css(styles.menuItemText)}`}>
                          {getHighlightedText(`${el.displayName}, ${el.credentials}`, anesthesiologistValue)}
                          <div>
                            {el.specialty}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </PopupMenu>
          }
        </div>
        {/* Anestehsiologists cards */}
        {anesthesiologists && Array.isArray(anesthesiologists) && anesthesiologists.length > 0 &&
          anesthesiologists.map((anesthesiologist, idx) => {
            return (
              <ProviderPracticeCard
                key={`${anesthesiologist._id || anesthesiologist.id || anesthesiologist.npi}__anesthesia_practice___${idx}`}
                data={anesthesiologist}
                date={scheduleStartDate}
                month={scheduleStartMonth}
                year={scheduleStartYear}
                showPractice={false}
                placeholderMsg='Search Practices'
                isDashboard={props.isDashboard}
                warningText='You must add at least 1 practice'
                index={idx}
                onUpdateStartType={(idx, type) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].startType = type;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      debugLogToConsole('NA');
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }
                }}
                onUpdateStartDate={(idx, year, month, date) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].startYear = year;
                  updatedAnesthesiologistsList[idx].startMonth = month;
                  updatedAnesthesiologistsList[idx].startDate = date;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      debugLogToConsole('NA');
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }
                }}
                onFlagUpdate={(index, startFlag, stopFlag) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[index].startFlag = startFlag;
                  updatedAnesthesiologistsList[index].stopFlag = stopFlag;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        if (!props.shoudlSaveCaseData) {
                          props.setShouldSaveCaseData(true);
                        }
                        props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                      }
                    }
                  }
                }}
                onUpdateStartTime={((idx, hour, min) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].startHour = hour;
                  updatedAnesthesiologistsList[idx].startMinute = min;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                    }
                  }
                })}
                onUpdateStopType={(idx, type) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].stopType = type;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                    }
                  }
                }}
                onUpdateStopDate={(idx, year, month, date) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].stopYear = year;
                  updatedAnesthesiologistsList[idx].stopMonth = month;
                  updatedAnesthesiologistsList[idx].stopDate = date;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                    }
                  }
                }}
                onUpdateStopTime={((idx, hour, min) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList[idx].stopHour = hour;
                  updatedAnesthesiologistsList[idx].stopMinute = min;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                    }
                  }
                })}
                onAddPractice={(data, index) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  let tmp = clone(updatedAnesthesiologistsList[index].addedPractices);
                  tmp = [].concat(data);
                  updatedAnesthesiologistsList[index].addedPractices = tmp;
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  if (props.forCaseBlocks) {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      debugLogToConsole('NA');
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }
                }}
                onDeletePractice={(practiceIndex, userId) => {
                  debugLogToConsole('Practice Deleted!');
                }}
                onDeleteProvider={(index) => {
                  const updatedAnesthesiologistsList = clone(anesthesiologists);
                  updatedAnesthesiologistsList.splice(index, 1);
                  const tmpProviders = [];
                  updatedAnesthesiologistsList.forEach(el => {
                    tmpProviders.push({ fullName: el.fullName });
                  });
                  setAnesthesiologists(updatedAnesthesiologistsList);
                  // props.onUpdatePatientCard('anesthesia', tmpProviders);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      anesthesiologists: updatedAnesthesiologistsList
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ anesthesiologists: updatedAnesthesiologistsList });
                    } else {
                      props.updateCaseSchedule({ anesthesiologists: updatedAnesthesiologistsList });
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }
                }}
              />
            );
          })
        }
      </div>

      {/* --- CNRAS ------------------------------------------------------- */}
      <div className={`p-2 ${css(styles.searchFormField, styles.lightBorderBottom)}`}>
        <div
          className='fx fx__v-center'
          style={{ justifyContent: 'space-between' }}
        >
          <CaseField
            heading='CRNA/CAA'
            showSearchIcon
            showAlert={showCrnaCriticalWarning}
            showIncomplete={showCrnaWarning}
            showPlusIcon={false}
            showNoneFlag={showCrnaNoneFlag}
          />
          <div className='pr-2' style={{ marginBottom: '1px' }}>
            <Checkbox
              text='None'
              isChecked={isNoneCrna}
              onChange={handleOnChangeIsNoneCrna}
            />
          </div>
        </div>
        {/* CRNA value textbox & search menu */}
        <div
          ref={crnaSearchMenuRef}
          className={`mt-0 ${css(styles.searchFormFieldTextboxContainer)}`}
          style={{
            display: isNoneCrna ? 'none' : ''
          }}
        >
          <TextInput
            value={crnaValue}
            disabled={isNoneCrna}
            placeholder="Search Practices/Providers"
            style={{
              width: `${DRAWER_WIDTH - 21}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onChange={(e) => {
              const { value } = e.target;
              setCrnaValue(value);
            }}
            onClick={() => setShowCrnasSearchMenu(true)}
          />
          {showCrnasSearchMenu &&
            <PopupMenu
              top={35}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showCrnasSearchMenu}
              parent={crnaSearchMenuRef}
              onOutsideClick={() => { setShowCrnasSearchMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                {Array.isArray(props.crnasSearchResults) &&
                  props.crnasSearchResults.length === 0 &&
                  <div className={css(styles.searchPopupMenuPlaceholder)}>
                    {props.searchingCrnas && 'Searching CRNAs...'}
                    {!props.searchingCrnas && props.crnasSearchResults.length === 0 && crnaValue.length === 0 &&
                      'Search CRNA in the text box above'
                    }
                    {!props.searchingCrnas && props.crnasSearchResults.length === 0 && crnaValue.length !== 0 &&
                      'No CRNA found!'
                    }
                    {/* {crnaSearchMsg} */}
                  </div>
                }
                {/* Providers */}
                {Array.isArray(props.crnasSearchResults) && props.crnasSearchResults.length > 0 &&
                  props.crnasSearchResults.map((el) => (
                    <div
                      key={el._id}
                      className={`fx fx__v-center ${css(styles.menuItem)}`}
                      style={{ height: '40px' }}
                      onClick={() => {
                        setShowCrnasSearchMenu(false);
                        setCrnaValue('');
                        const tmpCrna = {
                          id: el._id,
                          text: `${el.displayName}`,
                          icon: el.avatarImageUrl,
                          avatarImageUrl: el.avatarImageUrl,
                          user: el._id,
                          fullName: `${el.lastName}, ${el.firstName}`,
                          npi: el.npi,
                          caseRelation: el.taxonomy ? el.taxonomy.coloquial || el.taxonomy.desc : el.specialty,
                          credentials: el.credentials,
                          addedPractices: [],
                          startType: 'anesStart',
                          startFlag: FLAG_VALUE.success,
                          startDate: scheduleStartDate,
                          startMonth: scheduleStartMonth,
                          startYear: scheduleStartYear,
                          startHour: '',
                          startMinute: '',
                          stopType: 'anesStop',
                          stopFlag: FLAG_VALUE.success,
                          stopDate: scheduleStartDate,
                          stopMonth: scheduleStartMonth,
                          stopYear: scheduleStartYear,
                          stopHour: '',
                          stopMinute: ''
                        };

                        // Duplicate CRNA check
                        const duplicateCrnaIndex = crnas.findIndex((crna) => {
                          return crna.npi === el.npi;
                        });

                        if (duplicateCrnaIndex < 0) {
                          setCrnas((prevState) => {
                            if (prevState.findIndex(item => item.user === el._id) < 0) {
                              return prevState.concat(tmpCrna);
                            } else {
                              debugLogToConsole('CRNA entry already exists!');
                              return prevState;
                            }
                          });
                          const updatedCrnas = crnas.concat(tmpCrna);
                          if (props.forCaseBlocks) {
                            props.updateCaseBlockActiveCaseSchedule({ crnas: updatedCrnas });
                            if (!props.shoudlSaveCaseData) {
                              props.setShouldSaveCaseData(true);
                            }
                          } else {
                            if (!props.isDashboard) {
                              props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                            } else {
                              props.updateCaseSchedule({ crnas: updatedCrnas });
                              if (!props.shoudlSaveCaseData) {
                                props.setShouldSaveCaseData(true);
                              }
                            }
                          }
                        }
                        props.resetCrnaSearch();
                      }}
                    >
                      <div className='fx fx__v-center'>
                        <img
                          src={el.avatarImageUrl}
                          className={css(styles.menuItemAvatarImg)}
                        />
                        <div className={`ml-2 ${css(styles.menuItemText)}`}>
                          {getHighlightedText(`${el.displayName}, ${el.credentials}`, crnaValue)}
                          <div>
                            {el.specialty}
                          </div>
                        </div>
                      </div>
                      {/* {el.displayName} */}
                    </div>
                  ))
                }
              </div>
            </PopupMenu>
          }
        </div>
        {/* CRNAs cards */}
        {crnas && Array.isArray(crnas) && crnas.length > 0 &&
          crnas.map((crna, idx) => (
            <ProviderPracticeCard
              key={`${crna._id}__crna_practice__${idx}`}
              data={crna}
              date={scheduleStartDate}
              month={scheduleStartMonth}
              year={scheduleStartYear}
              showPractice={false}
              placeholderMsg='Search Practices'
              isDashboard={props.isDashboard}
              warningText='You must add at least 1 practice'
              index={idx}
              onFlagUpdate={(index, startFlag, stopFlag) => {
                const updatedCrnasList = clone(crnas);
                updatedCrnasList[index].startFlag = startFlag;
                updatedCrnasList[index].stopFlag = stopFlag;
                setCrnas(updatedCrnasList);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnasList });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnasList });
                  }
                }
              }}
              onUpdateStartType={(idx, type) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].startType = type;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnas });
                  }
                }
              }}
              onUpdateStartDate={(idx, year, month, date) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].startYear = year;
                updatedCrnas[idx].startMonth = month;
                updatedCrnas[idx].startDate = date;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    debugLogToConsole('NA');
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ crnas: updatedCrnas });
                    }
                  }
                }
              }}
              onUpdateStartTime={((idx, hour, min) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].startHour = hour;
                updatedCrnas[idx].startMinute = min;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnas });
                  }
                }
              })}
              onUpdateStopType={(idx, type) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].stopType = type;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnas });
                  }
                }
              }}
              onUpdateStopDate={(idx, year, month, date) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].stopYear = year;
                updatedCrnas[idx].stopMonth = month;
                updatedCrnas[idx].stopDate = date;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnas });
                  }
                }
              }}
              onUpdateStopTime={((idx, hour, min) => {
                const updatedCrnas = clone(crnas);
                updatedCrnas[idx].stopHour = hour;
                updatedCrnas[idx].stopMinute = min;
                setCrnas(updatedCrnas);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnas });
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                    props.updateCaseSchedule({ crnas: updatedCrnas });
                  }
                }
              })}
              onAddPractice={(data, index) => {
                const updatedCrnasList = clone(crnas);
                let tmp = clone(updatedCrnasList[index].addedPractices);
                tmp = [].concat(data);
                updatedCrnasList[index].addedPractices = tmp;
                setCrnas(updatedCrnasList);
                if (props.forCaseBlocks) {
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    debugLogToConsole('NA');
                  } else {
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }
              }}
              onDeletePractice={(practiceIndex, userId) => {
                debugLogToConsole('Not required any more');
              }}
              onDeleteProvider={(index) => {
                const updatedCrnasList = clone(crnas);
                updatedCrnasList.splice(index, 1);
                setCrnas(updatedCrnasList);
                if (props.forCaseBlocks) {
                  props.updateCaseBlockActiveCaseSchedule({ crnas: updatedCrnasList });
                  if (!props.shoudlSaveCaseData) {
                    props.setShouldSaveCaseData(true);
                  }
                } else {
                  if (!props.isDashboard) {
                    props.updateNewCaseScheduleData({ crnas: updatedCrnasList });
                  } else {
                    if (!props.isDashboard) {
                      props.updateNewCaseScheduleData({ crnas: updatedCrnasList });
                    } else {
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                      props.updateCaseSchedule({ crnas: updatedCrnasList });
                    }
                  }
                }
              }}
            />
          ))
        }
      </div>

      {/* --- CASE TIMES -------------------------------------------------- */}
      {props.isDashboard &&
        <>
          {/* Times Heading */}
          <div className={`p-2 mt-2 ${css(styles.formField)}`}>
            {/* Icon */}
            {showCaseTimesMasterWarning
              ? <CriticalWarningIcon height={14} />
              : <SuccessIcon height={16} />
            }
            {/* Label */}
            <div className='ml-2' style={{ flexGrow: '1' }}>Times</div>
          </div>

          {/* Anes Start Time */}
          <div className={`p-2 ${css(styles.formField)}`}>
            {/* Warning/Sucess Icon */}
            {isAnesthesiaStartTimePristine
              ? <CriticalWarningIcon height={16} />
              : <SuccessIcon height={16} />
            }
            <div className='fx fx__v-center'>
              {/* Label */}
              <div
                className='font-14__bold ml-2'
                style={{ minWidth: '80px', width: '80px' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="none"
                  className='mr-1'
                >
                  <path
                    fill="#96C8FF"
                    fillRule="evenodd"
                    d="M11.818.804 3.151 6l8.667 5.196V.804ZM0 12h2.1V0H0v12Z"
                    clipRule="evenodd"
                  />
                </svg>
                Anes
              </div>
              <DatePicker
                left={-91}
                right={2}
                date={anesthesiaStartDate}
                month={anesthesiaStartMonth}
                year={anesthesiaStartYear}
                isPrisitine={false}
                color={showAnesStartDateWarning ? yellow[500] : blue[500]}
                noUnderline
                readOnlyMode={isDosTbd}
                className={`font-14__bold ${css(isDosTbd && styles.disabled)}`}
                onChangeDate={(year, month, date) => {
                  setAnesthesiaStartDate(date);
                  setAnesthesiaStartMonth(month);
                  setAnesthesiaStartYear(year);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      anesthesiaStartDate: makeIsoDateString(year, month, date),
                      anesthesiaStartHour: !isAnesthesiaStartTimePristine ? anesthesiaStartHour : null,
                      anesthesiaStartMinute: !isAnesthesiaStartTimePristine ? anesthesiaStartMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      anesthesiaStartDate: makeIsoDateString(year, month, date),
                      anesthesiaStartHour: !isAnesthesiaStartTimePristine ? anesthesiaStartHour : null,
                      anesthesiaStartMinute: !isAnesthesiaStartTimePristine ? anesthesiaStartMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
              />
              <div className='ml-1 mr-1 font-14__bold'>@</div>
              <TimePicker
                className='font-14__bold'
                hour={anesthesiaStartHour}
                minute={anesthesiaStartMinute}
                color={isAnesthesiaStartTimePristine ? yellow[500] : blue[500]}
                noUnderline
                timeFormat='24H'
                timePeriod='AM'
                isPristine={isAnesthesiaStartTimePristine}
                onChangeTime={(hour, min) => {
                  setAnesthesiaStartHour(hour);
                  setAnesthesiaStartMinute(min);
                  setIsAnesthesiaStartTimePristine(false);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      anesthesiaStartDate: makeIsoDateString(anesthesiaStartYear, anesthesiaStartMonth, anesthesiaStartDate),
                      anesthesiaStartHour: hour,
                      anesthesiaStartMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      anesthesiaStartDate: makeIsoDateString(anesthesiaStartYear, anesthesiaStartMonth, anesthesiaStartDate),
                      anesthesiaStartHour: hour,
                      anesthesiaStartMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
                disableTimeFormat
              />
            </div>
          </div>

          {/* Surg Start Time */}
          <div className={`p-2 ${css(styles.formField)}`}>
            {/* Warning/Sucess Icon */}
            {showSurgStartWarning
              ? <CriticalWarningIcon height={16} />
              : <SuccessIcon height={16} />
            }
            <div className='fx fx__v-center'>
              {/* Label */}
              <div
                className='font-14__bold ml-2'
                style={{ minWidth: '80px', width: '80px' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="none"
                  className='mr-1'
                >
                  <path
                    fill="#96C8FF"
                    fillRule="evenodd"
                    d="M11.818.804 3.151 6l8.667 5.196V.804ZM0 12h2.1V0H0v12Z"
                    clipRule="evenodd"
                  />
                </svg>
                Surg
              </div>
              <DatePicker
                left={-91}
                right={2}
                date={surgeryStartDate}
                month={surgeryStartMonth}
                year={surgeryStartYear}
                isPrisitine={false}
                color={showSurgStartDateWarning ? yellow[500] : blue[500]}
                noUnderline
                readOnlyMode={isDosTbd}
                className={`font-14__bold ${css(isDosTbd && styles.disabled)}`}
                onChangeDate={(year, month, date) => {
                  setSurgeryStartDate(date);
                  setSurgeryStartMonth(month);
                  setSurgeryStartYear(year);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      surgeryStartDate: makeIsoDateString(year, month, date),
                      surgeryStartHour: !isSurgeryStartTimePristine ? surgeryStartHour : null,
                      surgeryStartMinute: !isSurgeryStartTimePristine ? surgeryStartMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      surgeryStartDate: makeIsoDateString(year, month, date),
                      surgeryStartHour: !isSurgeryStartTimePristine ? surgeryStartHour : null,
                      surgeryStartMinute: !isSurgeryStartTimePristine ? surgeryStartMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
              />
              <div className='ml-1 mr-1 font-14__bold'>@</div>
              <TimePicker
                className='font-14__bold'
                hour={surgeryStartHour}
                minute={surgeryStartMinute}
                color={isSurgeryStartTimePristine || showSurgStartWarning ? yellow[500] : blue[500]}
                noUnderline
                timeFormat='24H'
                timePeriod='AM'
                isPristine={isSurgeryStartTimePristine}
                onChangeTime={(hour, min) => {
                  setSurgeryStartHour(hour);
                  setSurgeryStartMinute(min);
                  setIsSurgeryStartTimePristine(false);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      surgeryStartDate: makeIsoDateString(surgeryStartYear, surgeryStartMonth, surgeryStartDate),
                      surgeryStartHour: hour,
                      surgeryStartMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      surgeryStartDate: makeIsoDateString(surgeryStartYear, surgeryStartMonth, surgeryStartDate),
                      surgeryStartHour: hour,
                      surgeryStartMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
                disableTimeFormat
              />
            </div>
          </div>

          {/* Surg End Time */}
          <div className={`p-2 ${css(styles.formField)}`}>
            {/* Warning/Sucess Icon */}
            {showSurgEndWarning
              ? <CriticalWarningIcon height={16} />
              : <SuccessIcon height={16} />
            }
            <div className='fx fx__v-center'>
              {/* Label */}
              <div
                className='font-14__bold ml-2'
                style={{ minWidth: '80px', width: '80px' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="none"
                  className='mr-1'
                >
                  <path
                    fill="#96C8FF"
                    fillRule="evenodd"
                    d="M0 11.196 8.667 6 0 .804v10.392ZM11.819 0H9.718v12h2.1V0Z"
                    clipRule="evenodd"
                  />
                </svg>
                Surg
              </div>
              <DatePicker
                left={-91}
                right={2}
                date={surgeryEndDate}
                month={surgeryEndMonth}
                year={surgeryEndYear}
                isPrisitine={false}
                color={showSurgEndDateWarning ? yellow[500] : blue[500]}
                noUnderline
                readOnlyMode={isDosTbd}
                className={`font-14__bold ${css(isDosTbd && styles.disabled)}`}
                onChangeDate={(year, month, date) => {
                  setSurgeryEndDate(date);
                  setSurgeryEndMonth(month);
                  setSurgeryEndYear(year);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      surgeryEndDate: makeIsoDateString(year, month, date),
                      surgeryEndHour: !isSurgeryEndTimePristine ? surgeryEndHour : null,
                      surgeryEndMinute: !isSurgeryEndTimePristine ? surgeryEndMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      surgeryEndDate: makeIsoDateString(year, month, date),
                      surgeryEndHour: !isSurgeryEndTimePristine ? surgeryEndHour : null,
                      surgeryEndMinute: !isSurgeryEndTimePristine ? surgeryEndMinute : null
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
              />
              <div className='ml-1 mr-1 font-14__bold'>@</div>
              <TimePicker
                className='font-14__bold'
                hour={surgeryEndHour}
                minute={surgeryEndMinute}
                color={isSurgeryEndTimePristine || showSurgEndWarning ? yellow[500] : blue[500]}
                noUnderline
                timeFormat='24H'
                timePeriod='AM'
                isPristine={isSurgeryEndTimePristine}
                onChangeTime={(hour, min) => {
                  setSurgeryEndHour(hour);
                  setSurgeryEndMinute(min);
                  setIsSurgeryEndTimePristine(false);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      surgeryEndDate: makeIsoDateString(surgeryEndYear, surgeryEndMonth, surgeryEndDate),
                      surgeryEndHour: hour,
                      surgeryEndMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      surgeryEndDate: makeIsoDateString(surgeryEndYear, surgeryEndMonth, surgeryEndDate),
                      surgeryEndHour: hour,
                      surgeryEndMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
                disableTimeFormat
              />
            </div>
          </div>

          {/* Anes End Time */}
          <div className={`p-2 ${css(styles.formField)}`}>
            {/* Warning/Sucess Icon */}
            {showAnesEndWarning
              ? <CriticalWarningIcon height={16} />
              : <SuccessIcon height={16} />
            }
            <div className='fx fx__v-center'>
              {/* Label */}
              <div
                className='font-14__bold ml-2'
                style={{ minWidth: '80px', width: '80px' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="none"
                  className='mr-1'
                >
                  <path
                    fill="#96C8FF"
                    fillRule="evenodd"
                    d="M0 11.196 8.667 6 0 .804v10.392ZM11.819 0H9.718v12h2.1V0Z"
                    clipRule="evenodd"
                  />
                </svg>
                Anes
              </div>
              <div style={{ position: 'relative' }}>
                <DatePicker
                  left={-91}
                  right={2}
                  date={anesthesiaEndDate}
                  month={anesthesiaEndMonth}
                  year={anesthesiaEndYear}
                  isPrisitine={false}
                  color={showAnesEndDateWarning ? yellow[500] : blue[500]}
                  noUnderline
                  readOnlyMode={isDosTbd}
                  className={`font-14__bold ${css(isDosTbd && styles.disabled)}`}
                  onChangeDate={(year, month, date) => {
                    setAnesthesiaEndDate(date);
                    setAnesthesiaEndMonth(month);
                    setAnesthesiaEndYear(year);
                    if (props.forCaseBlocks) {
                      props.updateCaseBlockActiveCaseSchedule({
                        anesthesiaEndDate: makeIsoDateString(year, month, date),
                        anesthesiaEndHour: !isAnesthesiaEndTimePristine ? anesthesiaEndHour : null,
                        anesthesiaEndMinute: !isAnesthesiaEndTimePristine ? anesthesiaEndMinute : null
                      });
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    } else {
                      props.updateCaseSchedule({
                        anesthesiaEndDate: makeIsoDateString(year, month, date),
                        anesthesiaEndHour: !isAnesthesiaEndTimePristine ? anesthesiaEndHour : null,
                        anesthesiaEndMinute: !isAnesthesiaEndTimePristine ? anesthesiaEndMinute : null
                      });
                      if (!props.shoudlSaveCaseData) {
                        props.setShouldSaveCaseData(true);
                      }
                    }
                  }}
                />
              </div>
              <div className='ml-1 mr-1 font-14__bold'>@</div>
              <TimePicker
                className='font-14__bold'
                hour={anesthesiaEndHour}
                minute={anesthesiaEndMinute}
                color={isAnesthesiaEndTimePristine || showAnesEndWarning ? yellow[500] : blue[500]}
                noUnderline
                timeFormat='24H'
                timePeriod='AM'
                isPristine={isAnesthesiaEndTimePristine}
                onChangeTime={(hour, min) => {
                  setAnesthesiaEndHour(hour);
                  setAnesthesiaEndMinute(min);
                  setIsAnesthesiaEndTimePristine(false);
                  if (props.forCaseBlocks) {
                    props.updateCaseBlockActiveCaseSchedule({
                      anesthesiaEndDate: makeIsoDateString(anesthesiaEndYear, anesthesiaEndMonth, anesthesiaEndDate),
                      anesthesiaEndHour: hour,
                      anesthesiaEndMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  } else {
                    props.updateCaseSchedule({
                      anesthesiaEndDate: makeIsoDateString(anesthesiaEndYear, anesthesiaEndMonth, anesthesiaEndDate),
                      anesthesiaEndHour: hour,
                      anesthesiaEndMinute: min
                    });
                    if (!props.shoudlSaveCaseData) {
                      props.setShouldSaveCaseData(true);
                    }
                  }
                }}
                disableTimeFormat
              />
            </div>
          </div>
        </>
      }
      {/* --- LIEN -------------------------------------------------------- */}
      <div className={`p-2 mt-2 ${css(styles.formField)}`}>
        {/* Icon */}
        {lien.length === 0
          ? <CriticalWarningIcon height={16} />
          : <SuccessIcon height={18} />
        }
        {/* Label */}
        <div className='ml-2' style={{ flexGrow: '1' }}>Lien</div>
        {/* Lien selection */}
        <div
          className='ml-2 fx'
          style={{
            border: `1px solid ${gray[400]}`,
            borderRadius: '4px',
            padding: '2px'
          }}
        >
          {/* No */}
          <PressedButton
            width={45}
            height={32}
            className={css(styles.pressedBtn, styles.admissionTypeBtn, lien.length === 0 && styles.pressedBtnCritical)}
            style={{ height: '22px' }}
            isPressed={lien === 'No'}
            onClick={handleOnClickNoLien}
          >
            No
          </PressedButton>
          {/* Yes */}
          <PressedButton
            width={45}
            height={32}
            className={`ml-1 ${css(styles.pressedBtn, styles.admissionTypeBtn, lien.length === 0 && styles.pressedBtnCritical)}`}
            style={{ height: '22px' }}
            isPressed={lien === 'Yes'}
            onClick={handleOnClickYesLien}
          >
            Yes
          </PressedButton>
        </div>
      </div>

      {/* --- WORKMAN COMP ------------------------------------------------ */}
      <div className={`p-2 mt-1 ${css(styles.formField)}`}>
        {/* Icon */}
        {workmanComp.length === 0
          ? <CriticalWarningIcon height={16} />
          : <SuccessIcon height={18} />
        }
        {/* Label */}
        <div className='ml-2' style={{ flexGrow: '1' }}>Workman&apos;s Comp</div>
        {/* Workman Comp selection */}
        <div
          className='ml-2 fx'
          style={{
            border: `1px solid ${gray[400]}`,
            borderRadius: '4px',
            padding: '2px'
          }}
        >
          {/* No */}
          <PressedButton
            width={45}
            height={32}
            className={css(styles.pressedBtn, styles.admissionTypeBtn, workmanComp.length === 0 && styles.pressedBtnCritical)}
            style={{ height: '22px' }}
            isPressed={workmanComp === 'No'}
            onClick={handleOnClickNoWorkmanComp}
          >
            No
          </PressedButton>
          {/* Yes */}
          <PressedButton
            width={45}
            height={32}
            className={`ml-1 ${css(styles.pressedBtn, styles.admissionTypeBtn, workmanComp.length === 0 && styles.pressedBtnCritical)}`}
            style={{ height: '22px' }}
            isPressed={workmanComp === 'Yes'}
            onClick={handleOnClickYesWorkmanComp}
          >
            Yes
          </PressedButton>
        </div>
      </div>

      {/* --- UNKNOWN END ------------------------------------------------- */}
      <div className={`p-2 mt-1 mb-1 ${css(styles.formField, styles.lightBorderBottom)}`}>
        {/* Icon */}
        {unknownEnd.length === 0
          ? <CriticalWarningIcon height={16} />
          : <SuccessIcon height={18} />
        }
        {/* Label */}
        <div className='ml-2' style={{ flexGrow: '1' }}>Unknown End</div>
        {/* Unknown End selection */}
        <div
          className='ml-2 fx'
          style={{
            border: `1px solid ${gray[400]}`,
            borderRadius: '4px',
            padding: '2px'
          }}
        >
          {/* No */}
          <PressedButton
            width={45}
            height={32}
            className={css(styles.pressedBtn, styles.admissionTypeBtn, unknownEnd.length === 0 && styles.pressedBtnCritical)}
            style={{ height: '22px' }}
            isPressed={unknownEnd === 'No'}
            onClick={handleOnClickNoUnknownEnd}
          >
            No
          </PressedButton>
          {/* Yes */}
          <PressedButton
            width={45}
            height={32}
            className={`ml-1 ${css(styles.pressedBtn, styles.admissionTypeBtn, unknownEnd.length === 0 && styles.pressedBtnCritical)}`}
            style={{ height: '22px' }}
            isPressed={unknownEnd === 'Yes'}
            onClick={handleOnClickYesUnknownEnd}
          >
            Yes
          </PressedButton>
        </div>
      </div>

      {/* --- SCHEDULING NOTES -------------------------------------------- */}
      <div className='p-2 mt-2' style={{ color: blue[200] }}>
        <div>Scheduling Notes</div>
        <textarea
          className={`mt-2 ${css(styles.notesTextArea)}`}
          placeholder="Type Note"
          value={schedulingNotes}
          onChange={handleOnChangeSchedulingNotes}
        />
      </div>

      {/* --- Spacer ------------------------------------------------------ */}
      <div className={css(styles.spacer)} />
    </>
  );
};

CaseTab.defaultProps = {
  isDashboard: false,
  forCaseBlocks: false
};

function mapStateToProps({ caseSchedule, sharedData }) {
  return {
    ...caseSchedule,
    ...sharedData
  };
}
export default connect(mapStateToProps, {
  updateNewCaseScheduleData,
  setCaseTabFlag,
  updateCaseSchedule,
  updateCaseBlockActiveCaseSchedule,
  searchFacilities,
  resetFacilitySearch,
  initiateFacilitySearch,
  initiateSurgeonSearch,
  searchSurgeons,
  resetSurgeonSearch,
  initiateAnesthesiologistSearch,
  searchAnesthesiologists,
  resetAnesthesiologistSearch,
  initiateCrnaSearch,
  searchCrnas,
  resetCrnaSearch,
  initiateCptSearch,
  searchCpt,
  resetCptSearch,
  initiateIcd10Search,
  searchIcd10,
  resetIcd10Search,
  shouldResyncCaseData,
  setShouldSaveCaseData
})(CaseTab);
